import React, { Component, Fragment } from "react";
import "./measurementModal.css";
import leftArrowImage from "../../../../assets/images/left-arrow.png";
import { SampleServices } from "../../../../services";
import "react-confirm-alert/src/react-confirm-alert.css";
import CustomModal from "../customModal/CustomModal";
import ReactToPrint from "react-to-print";
import { confirmAlert } from "react-confirm-alert"
import "react-confirm-alert/src/react-confirm-alert.css"
import _ from "lodash";
// import  Async from "react-select";

class MeasurementModal extends Component {
  state = {
    open: false,
    action: "",
    showModal:false,
    modalSearchInput:"",
    measurements: [
      {
        code: "C1",
        description: "Bust/Chest @2.5cm Below Underarm",
        tolMinus: "1.00",
        tolPlus: "1.00",
        sizes: {
          4: "1.00",
          8: "1.00",
          10: "1.00",
          12: "1.00",
          16: "1.00",
          18: "1.00",
        },
        comments: "Gathering Relaxed",
        bw: "1.00", // New field for BW
        aw: "1.00",
      },
    ],
    showDropdown: false,
    dropdownPosition: { top: 0, left: 0 },
    dropdownPositionAddMore: { top: 0, left: 0 },
    availableSizes: [],
    selectedSizes: [],
    measurements1: [],
    srList:[],
    srValueObj:null,
    shrinkagePercentage: {
      length: "",
      width: "",
    },
    additionalData: [], // To store data from the API
    selectedMeasurements: [], // To track selected measurements
    showDropdown1: false, // To control dropdown visibility
    dropdownRef: React.createRef(),
    buttonRef1: React.createRef(),
    dropdownRef1: React.createRef(),
    buttonRef2: React.createRef(),
    // srValue:{
    //   srvalueDup: ""
    // },
    isModalOpen: false, // Controls whether the modal is open or closed
    srValue: "",
    ItemNo: "",
    SampleType: "",
    SourceOfRequest: "",
    CustomerDept: "",
    typeOfRequest: "",
    Cusrefno: "",
    Magnumstylename: "",
    Magnumstyleno: "",
    GarmentType:"",
    isOpen1: false,
    isOpen2: false,
    SHRINKAGETYPEOPTIONS:[],
    rowHeights: {}, // Store heights for each row index
    _id: this.props.location.state._id,
  };

  openModal = () => this.setState({ open: true });
  closeModal = () => this.setState({ open: false });

  componentDidMount() {
    document.addEventListener("mousedown", this.handleClickOutside);
    this.updateRowHeights();
    const action =
      this.props.location.state && this.props.location.state.action
        ? this.props.location.state.action
        : null;
    this.setState({ action });
    const _id = this.props.location.state._id;
    SampleServices.SampleInfo(_id)
      .then((response) => {
        if (response.status === 200) {
          const fetchedMeasurements = response.text.data.measurementChat;
          //console.log(fetchedMeasurements,"fffff")

          // Extract selected sizes from the fetched measurements
          const selectedSizes = fetchedMeasurements
            .flatMap((measurement) => measurement.sizes || []) // Flatten all sizes into a single array
            .filter(
              (
                size,
                index,
                self // Remove duplicates
              ) =>
                index ===
                self.findIndex((s) => s.sizeOftype === size.sizeOftype)
            );

          // Update the state with fetched measurements and selected sizes
          this.setState({
            measurements1: fetchedMeasurements,
            selectedSizes: selectedSizes,
            shrinkagePercentage: {
              length: response.text.data.shrinkagePercentage.length,
              width: response.text.data.shrinkagePercentage.width,
            },
          });
        }
      })
      .catch((error) => {
        console.error("Error fetching data:", error);
      });
    // console.log(this.props.location.state.customer, "customer");
  //   SampleServices.SampleInfo(_id)
  // .then((response) => {
  //   if (response.status === 200) {
  //     const fetchedMeasurements = response.text.data.measurementChat;

  //     // ✅ Skip state update if measurementChat is missing or empty
  //     if (!Array.isArray(fetchedMeasurements) || fetchedMeasurements.length === 0) {
  //       return;
  //     }

  //     // Extract selected sizes from the fetched measurements
  //     const selectedSizes = fetchedMeasurements
  //       .flatMap((measurement) => measurement.sizes || []) // Flatten all sizes into a single array
  //       .filter(
  //         (size, index, self) =>
  //           index === self.findIndex((s) => s.sizeOftype === size.sizeOftype)
  //       );

  //     // Update the state with fetched measurements and selected sizes
  //     this.setState({
  //       measurements1: fetchedMeasurements,
  //       selectedSizes: selectedSizes,
  //       shrinkagePercentage: {
  //         length: response.text.data.shrinkagePercentage.length,
  //         width: response.text.data.shrinkagePercentage.width,
  //       },
  //     });
  //   }
  // })
  // .catch((error) => {
  //   console.error("Error fetching data:", error);
  // });


    SampleServices.measurementChatDetails(_id).then((response) => {
      if (response.status == 200) {
        const fetchedMeasurements = response.text.data.measurementChat;

          // Extract selected sizes from the fetched measurements
          const selectedSizes = fetchedMeasurements
            .flatMap((measurement) => measurement.sizes || []) // Flatten all sizes into a single array
            .filter(
              (
                size,
                index,
                self // Remove duplicates
              ) =>
                index ===
                self.findIndex((s) => s.sizeOftype === size.sizeOftype)
            );

          // Update the state with fetched measurements and selected sizes
          this.setState({
            measurements1: fetchedMeasurements,
            // selectedSizes: selectedSizes,
            // shrinkagePercentage: {
            //   length: response.text.data.shrinkagePercentage.length,
            //   width: response.text.data.shrinkagePercentage.width,
            // },
          });
        this.setState({
          Magnumstylename: response.text.data.magnumStyleName,
          Magnumstyleno: response.text.data.referenceCode,
          Cusrefno: response.text.data.customerRefNumber,
          CustomerDept: `${response.text.data.customerName}-${response.text.data.departmentName}`,
          SourceOfRequest: response.text.data.sampleRequest,
          SampleType: response.text.data.sampletype,
          ItemNo: response.text.data.itemNumber,
          typeOfRequest: response.text.data.typeOfRequest,
          GarmentType: response.text.data.garmentType,
        });
      }
    });
    SampleServices.measurementChatDetails(_id).then((response) => {
      if (response.status == 200) {
        this.setState({
          Magnumstylename: response.text.data.magnumStyleName,
          Magnumstyleno: response.text.data.referenceCode,
          Cusrefno: response.text.data.customerRefNumber,
          CustomerDept: `${response.text.data.customerName}-${response.text.data.departmentName}`,
          SourceOfRequest: response.text.data.sampleRequest,
          SampleType: response.text.data.sampletype,
          ItemNo: response.text.data.itemNumber,
          typeOfRequest: response.text.data.typeOfRequest,
          GarmentType: response.text.data.garmentType,
        });
      }
    });

    SampleServices.getCustomerData({
      customer: this.props.location.state.customer,
      customerDepartmentId: this.props.location.state.customerDepartmentId,
      type: this.props.location.state.type,
    })
      .then((response) => {
        if (response.status == 200) {
          const availableSizes = response.text.data.sizes.map(
            (size) => size.label.split(" - ")[0].trim() // Extract and trim the label before " - "
          );

          this.setState({
            availableSizes,
          });
        }
      })
      .catch((error) =>
        this.props.getalertMessage("error hell", error.toString())
      );

    const value = {
      magnumStyleId: this.props.location.state.magnumStyleId,
      sourceSampleRequestId: this.state._id,
    };

    SampleServices.addMoreTypeOfSize(value).then((response) => {
      if (response.status == 200) {
        //console.log(response,"addmor")
      }
    });

  SampleServices.prefillSRDetails()
  .then(response => {
    if (response.message === "Operation Successful") {
      //console.log(response,"res")
      this.setState({
        SHRINKAGETYPEOPTIONS: response.data.SAMPLEREQUEST.SHRINKAGETYPE
      });
    }
  })
  .catch(error => {
    console.error("Error fetching details:", error);
  });
  //console.log(this.state.SHRINKAGETYPEOPTIONS,"op")

  SampleServices.getSampleReqNo("")
          .then(response => {
            if (response.status === 200) {
              this.setState({
                srList: response.text.data,
              })
            }
            response.status == 401 && this.props.unauthorisedFunc()
          })
          .catch(error => this.props.getalertMessage("error", error.toString()))

  }
  componentDidUpdate(prevProps, prevState) {
    if (prevState.measurements1 !== this.state.measurements1) {
      this.updateRowHeights();
    }
  }

  componentWillUnmount() {
    document.removeEventListener("mousedown", this.handleClickOutside);
  }

  updateRowHeights = () => {
    const heights = {};
    this.state.measurements1.forEach((_, index) => {
      const td = document.getElementById(`measurement-td-${index}`);
      if (td) {
        heights[index] = td.offsetHeight;
      }
    });
    this.setState({ rowHeights: heights });
  };

  handleClickOutside = (event) => {
    const { dropdownRef, buttonRef1, dropdownRef1, buttonRef2 } = this.state;

    if (
      dropdownRef.current &&
      !dropdownRef.current.contains(event.target) &&
      buttonRef1.current &&
      !buttonRef1.current.contains(event.target)
    ) {
      // Hide the dropdown if the click is outside the dropdown and the button
      this.setState({ showDropdown1: false, isOpen2: false });
    }

    if (
      dropdownRef1.current &&
      !dropdownRef1.current.contains(event.target) &&
      buttonRef2.current &&
      !buttonRef2.current.contains(event.target)
    ) {
      this.setState({ showDropdown: false, isOpen1: false });
    }
  };

  openModal = () => {
    this.setState({ isModalOpen: true });
  };

  // Close the modal
  closeModal = () => {
    this.setState({ isModalOpen: false, srValue: "", srValueObj:null });
  };

  // Handle input change
  handleInputChange = (e) => {
    this.setState({ srValue: e.target.value });
  };

  // Handle save action (calling API and resetting state)

  duplicateMC = () => {
    const { _id, srValue } = this.state;
    const data = srValue;
    SampleServices.duplicateMeasurementChat(data, _id)
      .then((response) => {
        if (response.status == 200) {
          this.props.getalertMessage(
            "success",
            "Measurement Chart duplicated successfully"
          );
          this.setState({ isModalOpen: false, srValue: "" },()=>{
            window.location.reload();
          });
        } else {
          this.props.getalertMessage("error", "enter the correct SR Number");
        }
      })
      .catch((error) =>
        this.props.getalertMessage("error", "enter the correct SR Number")
      );
  };
  handleDupInputChange = (e) => {
    let value = e.target.value;

    // Prevent leading space
    if (/^\s/.test(value)) {
      return; // Do nothing if first character is a space
    }
    this.setState({ srValue: e.target.value });
  };

  // openDuplicateModal = () => {

  //   confirmAlert({
  //     customUI: ({ onClose }) => {
  //       return (
  //         <div className="custom-ui">
  //           <h1>Duplicate File</h1>
  //           <label>Sample Request Id</label>
  //           <input
  //             type="text"
  //             value={this.state.srValue.srvalueDup || ""}
  //             name="srvalueDup"
  //             onChange={ this.handleDupInputChange}
  //             placeholder="Enter Sample Request ID"
  //           />
  //           <div style={{ marginTop: "20px" }}>
  //             <button
  //               style={{
  //                 padding: "4px 14px",
  //       backgroundColor: "#009688",
  //       color: "white",
  //       border: "none",
  //       borderRadius: "4px",
  //       cursor: "pointer",
  //               }}
  //               onClick={() => {
  //                 this.duplicateMC(); // Call the API
  //                 // this.setState({ srValue: "" }); // Reset state
  //                 onClose(); // Close the modal
  //               }}
  //             >
  //               Save
  //             </button>
  //             <button
  //               style={{
  //                 backgroundColor: "white",
  //                 color: "#009688",
  //                 border: "1px solid #009688",
  //                 borderRadius: "5px",
  //                 padding: "4px 14px",
  //                 cursor: "pointer",
  //               }}
  //               onClick={() => {
  //                 // this.setState({ srValue: "" }); // Reset state
  //                 onClose(); // Close the modal
  //               }}

  //             >
  //               Cancel
  //             </button>
  //           </div>
  //         </div>
  //       );
  //     },
  //     closeOnClickOutside: true,
  //   });
  // };

  handleAddRow = () => {
    const newRow = {
      code: `C${this.state.measurements.length + 1}`,
      description: "",
      tolMinus: "1.00",
      tolPlus: "1.00",
      sizes: [],
      comments: "",
      bw: "", // New field for BW
      aw: "",
    };
    this.setState((prevState) => ({
      measurements: [...prevState.measurements, newRow],
    }));
  };

  //   handleAddMore = () => {
  //     const value = ({magnumStyleId:this.props.location.state.magnumStyleId,sourceSampleRequestId:this.state._id})
  //     SampleServices.addMoreTypeOfSize(value).then(response => {
  //       if (response.status === 200) {
  //         const newData = response.data; // New data from the API
  //         this.mergeMeasurements(newData); // Merge new data with existing measurements
  //       }
  //     })
  //     .catch((error) => {
  //       console.error("Error fetching add more data:", error);
  //     });
  // };

  // Function to merge new data with existing measurements
  // mergeMeasurements = (newData) => {
  //   this.setState((prevState) => {
  //     const existingMeasurements = prevState.measurements1;

  //     // Merge new data with existing measurements
  //     const mergedMeasurements = newData.map((newItem) => {
  //       // Check if the item already exists in measurements1
  //       const existingItem = existingMeasurements.find(
  //         (item) => item.code === newItem.code
  //       );

  //       // If the item exists, preserve its sizes (if any)
  //       if (existingItem) {
  //         return {
  //           ...newItem,
  //           sizes: existingItem.sizes || [], // Preserve existing sizes
  //         };
  //       }

  //       // If the item does not exist, add it with an empty sizes array
  //       return {
  //         ...newItem,
  //         sizes: [], // Initialize sizes as an empty array
  //       };
  //     });

  //     // Update the state with merged measurements
  //     return {
  //       measurements1: mergedMeasurements,
  //     };
  //   });
  // };

  // handleAddMore = async () => {
  //   try {
  //     const value = {
  //       magnumStyleId: this.props.location.state.magnumStyleId,
  //       sourceSampleRequestId: this.state._id,
  //     };

  //     const response = await SampleServices.addMoreTypeOfSize(value);

  //     if (response.status == 200) {
  //       this.setState({
  //         additionalData: response.text.data, // Store fetched data
  //         showDropdown1: true, // Show the dropdown
  //       });
  //       console.log(this.state.showDropdown1,"d1")
  //     }
  //   } catch (error) {
  //     console.error("Error fetching additional data:", error);
  //   }
  // };

  // handleAddMore = async () => {
  //   const { showDropdown1 } = this.state;
  //   this.setState((prevState) => ({
  //     isOpen2: !prevState.isOpen2,
  //   }));

  //   if (!showDropdown1) {
  //     try {
  //       const value = {
  //         magnumStyleId: this.props.location.state.magnumStyleId,
  //         sourceSampleRequestId: this.state._id,
  //       };

  //       const response = await SampleServices.addMoreTypeOfSize(value);
  //       if (response.status === 404) {
  //         this.props.getalertMessage("error", response.text.message);
  //       }

  //       if (response.status === 200 && this.state.buttonRef1) {
  //         const buttonRect =
  //           this.state.buttonRef1.current.getBoundingClientRect();
  //         this.setState({
  //           additionalData: response.text.data, // Store fetched data
  //           showDropdown1: true, // Show the dropdown
  //           dropdownPositionAddMore: {
  //             top: buttonRect.bottom + window.scrollY, // Set top position
  //             left: buttonRect.left + window.scrollX, // Set left position
  //           },
  //         });
  //       }
  //     } catch (error) {
  //       console.error("Error fetching additional data:", error);
  //     }
  //   } else {
  //     // Hide the dropdown if it's already visible
  //     this.setState({ showDropdown1: false });
  //   }
  // };


  handleAddMore = async () => {
    const { showDropdown1 } = this.state;
    this.setState((prevState) => ({
      isOpen2: !prevState.isOpen2,
    }));
  
    if (!showDropdown1) {
      try {
        const value = {
          magnumStyleId: this.props.location.state.magnumStyleId,
          sourceSampleRequestId: this.state._id,
        };
  
        const response = await SampleServices.addMoreTypeOfSize(value);
  
        if (response.status === 404) {
          this.props.getalertMessage("error", response.text.message);
        }
  
        if (response.status === 200 && this.state.buttonRef1) {
          // const buttonRect = this.state.buttonRef1.current.getBoundingClientRect();
  
          this.setState({
            additionalData: response.text.data, // Store fetched data
            showDropdown1: false, // Hide dropdown
            showModal: true, // Open the modal
            // dropdownPositionAddMore: {
            //   top: buttonRect.bottom + window.scrollY,
            //   left: buttonRect.left + window.scrollX,
            // },
          }, () => {
            //console.log("Updated additionalData:", this.state.additionalData);
          });
        }
      } catch (error) {
        console.error("Error fetching additional data:", error);
      }
    } else {
      this.setState({ showDropdown1: false });
    }
  };
  

  renderDropdown = () => {
    const {
      additionalData,
      selectedMeasurements,
      dropdownRef,
      dropdownPositionAddMore,
    } = this.state;

    return (
      // <ul
      //   style={{
      //     position: "absolute",
      //     // top: dropdownPositionAddMore.top, // Use the calculated top position
      //     // left: dropdownPositionAddMore.left, // Use the calculated left position
      //     listStyleType: "none",
      //     padding: "8px",
      //     backgroundColor: "white",
      //     border: "1px solid #ddd",
      //     borderRadius: "4px",
      //     boxShadow: "0 4px 6px rgba(0, 0, 0, 0.1)",
      //     maxHeight: "200px",
      //     overflowY: "auto",
      //      width: "100%"
      //   }}
      // >
      // additionalData.map((item) => (
      //   <li
      //     key={item.code}
      //     style={{
      //       padding: "6px 12px",

      //       borderBottom: "1px solid #f0f0f0",
      //       display: "flex",
      //       alignItems: "center",
      //     }}
      //   >
      //     <input
      //       type="checkbox"
      //       checked={selectedMeasurements.some((m) => m.code === item.code)}
      //       onChange={() => this.handleCheckboxChange(item)}
      //       style={{ marginRight: "8px",
      //         position: "static", // Reset position
      //         left: "auto",       // Reset left positioning
      //         opacity: 1,
      //         cursor: "pointer",
      //        }}
      //     />
      //     {item.placeofMeasurement}
      //   </li>
      // ))
      <div>
        {additionalData.length > 0 ? (
          additionalData.map((item) => (
            <li
              key={item.code}
              style={{
                padding: "6px 12px",
                borderBottom: "1px solid #f0f0f0",
                display: "flex",
                alignItems: "center",
              }}
            >
              <input
                type="checkbox"
                checked={selectedMeasurements.some((m) => m.placeofMeasurement === item.placeofMeasurement)}
                onChange={() => this.handleCheckboxChange(item)}
                style={{
                  marginRight: "8px",
                  position: "static", // Reset position
                  left: "auto", // Reset left positioning
                  opacity: 1,
                  cursor: "pointer",
                }}
              />
              {item.placeofMeasurement}
            </li>
          ))
        ) : (
          <li
            style={{
              padding: "12px",
              textAlign: "center",
              color: "#999",
            }}
          >
            No data available
          </li>
        )}
      </div>
    );
  };



  

  // handleCheckboxChange = (item) => {
  //   const { selectedMeasurements, measurements1, selectedSizes } = this.state;

  //   // Check if the item is already selected
  //   const isSelected = selectedMeasurements.some((m) => m.code === item.code);

  //   if (isSelected) {
  //     // Remove the item if already selected
  //     const updatedSelectedMeasurements = selectedMeasurements.filter(
  //       (m) => m.code !== item.code
  //     );
  //     const updatedMeasurements1 = measurements1.filter(
  //       (m) => m.code !== item.code
  //     );
  //     //console.log(updatedSelectedMeasurements,"updat")

  //     this.setState({
  //       selectedMeasurements: updatedSelectedMeasurements,
  //       measurements1: updatedMeasurements1,
  //     });
  //   } else {
  //     // Create the sizes array dynamically based on selectedSizes
  //     const sizes = selectedSizes.map((size, index) => ({
  //       sizeOftype: size.sizeOftype, // Use the sizeOftype from selectedSizes
  //       awSpec: null,
  //       awQA: null,
  //       bwSpec: null,
  //       bwQA: null,
  //     }));

  //     // Create the new measurement object
  //     const newMeasurement = {
  //       ...item,
  //       tolMinus: "",
  //       tolPlus: "",
  //       comments: "",
  //       sizes: sizes, // Add the dynamically created sizes array
  //     };

  //     // Update the state
  //     this.setState((prevState) => ({
  //       selectedMeasurements: [
  //         ...prevState.selectedMeasurements,
  //         newMeasurement,
  //       ],
  //       measurements1: [...prevState.measurements1, newMeasurement],
  //     }));
  //   }
  // }


  handleCheckboxChange = (item) => {
    const { selectedMeasurements, measurements1, selectedSizes } = this.state;

    // Check if the item is already selected based on placeofMeasurement
    const isSelected = selectedMeasurements.some((m) => m.placeofMeasurement === item.placeofMeasurement);

    if (isSelected) {
      // Remove the item if already selected
      const updatedSelectedMeasurements = selectedMeasurements.filter(
        (m) => m.placeofMeasurement !== item.placeofMeasurement
      );
      const updatedMeasurements1 = measurements1.filter(
        (m) => m.placeofMeasurement !== item.placeofMeasurement
      );

      this.setState({
        selectedMeasurements: updatedSelectedMeasurements,
        measurements1: updatedMeasurements1,
      });
    } else {
      // Create the sizes array dynamically based on selectedSizes
      const sizes = selectedSizes.map((size) => ({
        sizeOftype: size.sizeOftype,
        awSpec: null,
        awQA: null,
        bwSpec: null,
        bwQA: null,
      }));

      // Create the new measurement object
      const newMeasurement = {
        ...item,
        tolMinus: "",
        tolPlus: "",
        comments: "",
        sizes: sizes,
      };

      // Update the state
      this.setState((prevState) => ({
        selectedMeasurements: [...prevState.selectedMeasurements, newMeasurement],
        measurements1: [...prevState.measurements1, newMeasurement],
      }));
    }
  }


  // handleSelectAllPOMs = () => {
  //   const { additionalData, selectedMeasurements, selectedSizes } = this.state;
  
  //   // Check if all items are already selected
  //   const allSelected = additionalData.length > 0 &&
  //     selectedMeasurements.length === additionalData.length;
  
  //   if (allSelected) {
  //     // If all are selected, clear selections
  //     this.setState({
  //       selectedMeasurements: [],
  //       // measurements1: [],
  //     });
  //   } else {
  //     // Select all
  //     const newMeasurements = additionalData.map((item) => {
  //       const sizes = selectedSizes.map((size) => ({
  //         sizeOftype: size.sizeOftype,
  //         awSpec: null,
  //         awQA: null,
  //         bwSpec: null,
  //         bwQA: null,
  //       }));
  
  //       return {
  //         ...item,
  //         tolMinus: "",
  //         tolPlus: "",
  //         comments: "",
  //         sizes: sizes,
  //       };
  //     });
  
  //     this.setState({
  //       selectedMeasurements: newMeasurements,
  //       measurements1: newMeasurements,
  //     });
  //   }
  // }
  


  // handleInputChange = (index, field, value) => {
  //   const regex = /^\d{0,5}(?:\.\d{0,5})?$/;
  //   if (!regex.test(value)) return;
  //   const updatedMeasurements = [...this.state.measurements1];
  //    if (field === "sizes") {
  //      updatedMeasurements[index].sizes = { ...updatedMeasurements[index].sizes, ...value };
  //    }else {
  //     updatedMeasurements[index][field] = value;
  //   }
  //   this.setState({ measurements1: updatedMeasurements });
  // }

  handleSelectAllPOMs = () => {
    const { additionalData, selectedMeasurements, selectedSizes, measurements1 } = this.state;
  
    // Check if all items are already selected
    const allSelected = additionalData.length > 0 &&
      selectedMeasurements.length === additionalData.length;
  
    if (allSelected) {
      // If all are selected, remove only the selected ones from `selectedMeasurements` and `measurements1`
      // Filtering `measurements1` to keep only items that are NOT in `additionalData`
      // `.some(...)` checks if `m.placeofMeasurement` exists in `additionalData`
      // `!` negates the result to remove matching items (selected ones) while keeping default data
      const updatedMeasurements1 = measurements1.filter(
        (m) => !additionalData.some((item) => item.placeofMeasurement === m.placeofMeasurement)
      );
  
      this.setState({
        selectedMeasurements: [],
        measurements1: updatedMeasurements1, // Keep existing default data
      });
    } else {
      // Select all
      const newMeasurements = additionalData.map((item) => {
        const sizes = selectedSizes.map((size) => ({
          sizeOftype: size.sizeOftype,
          awSpec: null,
          awQA: null,
          bwSpec: null,
          bwQA: null,
        }));
  
        return {
          ...item,
          tolMinus: "",
          tolPlus: "",
          comments: "",
          sizes: sizes,
        };
      });
  
      this.setState({
        selectedMeasurements: newMeasurements,
        measurements1: [...measurements1, ...newMeasurements], // Append to existing data
      });
    }
  };
  

  handleInputChange = (index, field, value) => {
    let updatedValue = value;

    if (field === "comments" || field === "dispatchComments") {
      // Prevent leading spaces and allow only single space between words
      updatedValue = value.trimStart().replace(/\s+/g, " ");
    } else {
      // Apply numeric validation only if it's not "comments"
      const regex = /^\d{0,5}(?:\.\d{0,5})?$/;
      if (!regex.test(value)) return;
    }

    // Create a copy of measurements1 to avoid direct mutation
    const updatedMeasurements = [...this.state.measurements1];

    if (field === "sizes") {
      updatedMeasurements[index].sizes = {
        ...updatedMeasurements[index].sizes,
        ...updatedValue,
      };
    } else {
      updatedMeasurements[index][field] = updatedValue;
    }

    // Update the state
    this.setState({ measurements1: updatedMeasurements });
  };

  handleInputChange1 = (rowIndex, sizeType, field, value) => {
    //const regex = /^\d*\.?\d{0,2}$/;
    // const regex = /^\d{0,3}(?:\.\d{0,2})?$/;
    const regex = /^[-+]?\d{0,3}(?:\.\d{0,2})?$/;
    if (!regex.test(value)) return;
    const updatedMeasurements = [...this.state.measurements1];

    const sizesArray = updatedMeasurements[rowIndex].sizes;

    const updateSize = { ...sizesArray[sizeType] };

    updateSize[field] = value;

    sizesArray[sizeType] = updateSize;

    this.setState({ measurements1: updatedMeasurements });
  };

  handleShrinkageChange = (e) => {
    const { name, value } = e.target; // Destructure name and value from the event target
    //const regex = /^\d{0,5}(?:\.\d{0,5})?$/;
    const regex = /^\d{0,5}(\.\d{0,5})?$/;
    if (!regex.test(value)) return;
    this.setState(
      (prevState) => ({
        shrinkagePercentage: {
          ...prevState.shrinkagePercentage, // Keep the other shrinkage properties unchanged
          [name]: value, // Update the specific property (length or width)
        },
      }),
      () => {
        this.updateMeasurementChat(); // Update the measurement chart after shrinkage change
      }
    );
  };

  toggleDropdown = () => {
    this.setState((prevState) => ({
      isOpen1: !prevState.isOpen1,
    }));
    this.setState({ showDropdown: !this.state.showDropdown });
  };

  // Handle adding a new size to all rows
  handleAddSize = (size) => {
    const isAlreadySelected = this.state.selectedSizes.some(
      (s) => s.sizeOftype === size
    );

    if (isAlreadySelected) {
      // Remove the size if it's already selected
      const updatedSelectedSizes = this.state.selectedSizes.filter(
        (s) => s.sizeOftype !== size
      );
      const updatedMeasurements = this.state.measurements1.map(
        (measurement) => ({
          ...measurement,
          sizes: (measurement.sizes || []).filter((s) => s.sizeOftype !== size), // Ensure sizes is an array
        })
      );

      this.setState({
        selectedSizes: updatedSelectedSizes,
        measurements1: updatedMeasurements,
      });
    } else {
      // Add the size if it's not selected
      const newSize = {
        sizeOftype: size,
        awSpec: "",
        awQA: "",
        bwSpec: "",
        bwQA: "",
      };

      const updatedSelectedSizes = [...this.state.selectedSizes, newSize];
      const updatedMeasurements = this.state.measurements1.map(
        (measurement) => ({
          ...measurement,
          sizes: [...(measurement.sizes || []), newSize], // Ensure sizes is an array
        })
      );

      this.setState({
        selectedSizes: updatedSelectedSizes,
        measurements1: updatedMeasurements,
        //showDropdown: false,
      });
    }
  };

  saveChart = () => {
    const { measurements1, shrinkagePercentage, _id } = this.state;
    SampleServices.saveMeasurementChar(measurements1, shrinkagePercentage, _id)
      .then((res) => {
        if (res.status == 200) {
          this.props.getalertMessage(
            "success",
            "Measurement Chart saved successfully"
          );
          this.setState({
            selectedMeasurements: []
          });
        }
      })
      .catch((error) => this.props.getalertMessage("error", error.toString()));
  };

  // updateMeasurementChat = () => {
  //   const updatedMeasurementChat = this.state.measurements1.map(
  //     (measurement) => {
  //       const { length: lengthPercentage, width: widthPercentage } =
  //         this.state.shrinkagePercentage;

  //       // If shrinkageType is missing, set bwSpec to "0.00"
  //       if (!measurement.shrinkageType) {
  //         const updatedSizes = measurement.sizes.map((size) => ({
  //           ...size,
  //           bwSpec: "0.00", // Default value
  //         }));

  //         return {
  //           ...measurement,
  //           sizes: updatedSizes,
  //         };
  //       }


  //       console.log(measurement.shrinkageType,"type")

  //       if (measurement.shrinkageType === "LENGTH") {
  //         const updatedSizes = measurement.sizes.map((size) => {
  //           if (size.awSpec !== null) {
  //             const awSpec = parseFloat(size.awSpec);
  //             const shrinkagePercentage = parseFloat(lengthPercentage);
  //             if (!isNaN(awSpec) && !isNaN(shrinkagePercentage)) {
  //               const bwSpec = awSpec + (awSpec * shrinkagePercentage) / 100;
  //               return {
  //                 ...size,
  //                 bwSpec: bwSpec.toFixed(2),
  //               };
  //             }
  //           }
  //           return { ...size, bwSpec: "0.00" }; // Default if awSpec is invalid
  //         });

  //         return {
  //           ...measurement,
  //           sizes: updatedSizes,
  //         };
  //       }

  //       if (measurement.shrinkageType === "WIDTH") {
  //         const updatedSizes = measurement.sizes.map((size) => {
  //           if (size.awSpec !== null) {
  //             const awSpec = parseFloat(size.awSpec);
  //             const shrinkagePercentage = parseFloat(widthPercentage);
  //             if (!isNaN(awSpec) && !isNaN(shrinkagePercentage)) {
  //               const bwSpec = awSpec + (awSpec * shrinkagePercentage) / 100;
  //               return {
  //                 ...size,
  //                 bwSpec: bwSpec.toFixed(2),
  //               };
  //             }
  //           }
  //           return { ...size, bwSpec: "0.00" }; // Default if awSpec is invalid
  //         });

  //         return {
  //           ...measurement,
  //           sizes: updatedSizes,
  //         };
  //       }

  //       return measurement;
  //     }
  //   );

  //   // Update the state with the modified measurements
  //   this.setState({ measurements1: updatedMeasurementChat });
  // }


  updateMeasurementChat = () => {
  
    // Map through each measurement
    const updatedMeasurementChat = this.state.measurements1.map((measurement) => {
      // Find the matching label for the shrinkageType (ID)
      const shrinkageTypeObj = this.state.SHRINKAGETYPEOPTIONS.find(option => option.value === measurement.shrinkageType);
      const shrinkageLabel = shrinkageTypeObj ? shrinkageTypeObj.label : null;
      const { length: lengthPercentage, width: widthPercentage } = this.state.shrinkagePercentage;
  
      // If shrinkageType is missing, set bwSpec to "0.00"
      if (!shrinkageLabel) {
        return {
          ...measurement,
          sizes: measurement.sizes.map((size) => ({
            ...size,
            bwSpec: "0.00", // Default value
          })),
        };
      }
  
      //console.log(shrinkageLabel, "type"); // Now this will log the label instead of ID
  
      // Perform calculations based on shrinkage type
      if (shrinkageLabel === "Length") {
                const updatedSizes = measurement.sizes.map((size) => {
                  if (size.awSpec !== null) {
                    const awSpec = parseFloat(size.awSpec);
                    const shrinkagePercentage = parseFloat(lengthPercentage);
                    if (!isNaN(awSpec) && !isNaN(shrinkagePercentage)) {
                      const bwSpec = awSpec + (awSpec * shrinkagePercentage) / 100;
                      return {
                        ...size,
                        bwSpec: bwSpec.toFixed(2),
                      };
                    }
                  }
                  return { ...size, bwSpec: "0.00" }; // Default if awSpec is invalid
                });
                //console.log(updatedSizes,"size")
      
                return {
                  ...measurement,
                  sizes: updatedSizes,
                };
              }
  
              if (shrinkageLabel === "Width") {
                        const updatedSizes = measurement.sizes.map((size) => {
                          if (size.awSpec !== null) {
                            const awSpec = parseFloat(size.awSpec);
                            const shrinkagePercentage = parseFloat(widthPercentage);
                            if (!isNaN(awSpec) && !isNaN(shrinkagePercentage)) {
                              const bwSpec = awSpec + (awSpec * shrinkagePercentage) / 100;
                              return {
                                ...size,
                                bwSpec: bwSpec.toFixed(2),
                              };
                            }
                          }
                          return { ...size, bwSpec: "0.00" }; // Default if awSpec is invalid
                        });
              
                        return {
                          ...measurement,
                          sizes: updatedSizes,
                        };
                      }
  
      return measurement;
    });


    //console.log(updatedMeasurementChat,"up")
  
    // Update the state with the modified measurements
    this.setState({ measurements1: updatedMeasurementChat });
  };
  

  handleDeleteRow = (indexToDelete) => {
    this.setState(
      (prevState) => {
        // Ensure the index exists before trying to access it
        if (
          indexToDelete < 0 ||
          indexToDelete >= prevState.measurements1.length
        ) {
          return null; // Return null to prevent state update if the index is invalid
        }

        // Extract the deleted item safely
        const deletedItem = prevState.measurements1[indexToDelete];

        // Filter out the deleted row and update the state
        const updatedMeasurements = prevState.measurements1.filter(
          (_, index) => index !== indexToDelete
        );
        const updatedSelectedMeasurements =
          prevState.selectedMeasurements.filter(
            (m) => m.code !== deletedItem.code
          );

        return {
          measurements1: updatedMeasurements,
          selectedMeasurements: updatedSelectedMeasurements,
        };
      },
      () => {
        // Ensure the API call runs after the state update
        const { measurements1, shrinkagePercentage, _id } = this.state;

        SampleServices.saveMeasurementChar(
          measurements1,
          shrinkagePercentage,
          _id
        )
          .then((res) => {
            if (res.status === 200) {
              this.props.getalertMessage(
                "error",
                "Measurement Chart's row deleted"
              );
            }
          })
          .catch((error) =>
            this.props.getalertMessage("error", error.toString())
          );
      }
    );
  };

  // Size Table Component for inside the main table
  SizeTable = ({ row, index }) => {
    const { selectedSizes } = this.state;
    const { state } = this.props.location;
    const header = state ? state.header : "Default Header";
    const isDispatch = header === "Dispatch ";
    const inputDispatchField = isDispatch ? "200px" : "";

    return (
      <table
        style={{
          // tableLayout: "fixed",
          width: "100%",
          borderSpacing: "0px",
          borderCollapse: "separate",
          backgroundColor: "white",
          marginBottom: index === 0 ? "16px" : "0px",
        }}
      >
        {index === 0 && (
          <thead>
            <tr>
              <th style={{ width: "53px", padding:"0px" }}>
                <button
                  onClick={this.toggleDropdown}
                  style={{
                    padding: "6px 12px",
                    backgroundColor: "#009688",
                    color: "white",
                    border: "none",
                    borderRadius: "4px",
                    cursor: "pointer",
                  }}
                  ref={(el) => (this.buttonRef = el)} // Reference to the button
                >
                  <i className="fa fa-plus" style={{ fontSize: "12px" }}></i>{" "}
                  {/* Add icon */}
                </button>

                {this.state.showDropdown && (
                  <ul
                    style={{
                      position: "fixed", // Use fixed position
                      top: this.state.dropdownPosition.top,
                      left: this.state.dropdownPosition.left,
                      listStyleType: "none",
                      padding: "8px",
                      backgroundColor: "white",
                      border: "1px solid #ddd",
                      borderRadius: "4px",
                      boxShadow: "0 4px 6px rgba(0, 0, 0, 0.1)",
                      maxHeight: "200px", // Set a fixed height for scrolling
                      overflowY: "auto", // Enable vertical scrolling
                      zIndex: 1000,
                    }}
                  >
                    {this.state.availableSizes.map((size) => (
                      <li
                        key={size}
                        style={{
                          padding: "6px 12px",

                          borderBottom: "1px solid #f0f0f0",
                          display: "flex",
                          alignItems: "center",
                        }}
                      >
                        <input
                          type="checkbox"
                          checked={this.state.selectedSizes.some(
                            (s) => s.sizeOftype === size
                          )}
                          onChange={() => this.handleAddSize(size)}
                          style={{
                            marginRight: "8px",
                            position: "static", // Reset position
                            left: "auto", // Reset left positioning
                            opacity: 1,
                            cursor: "pointer",
                          }}
                        />
                        {size}
                      </li>
                    ))}
                  </ul>
                )}
              </th>

              {selectedSizes.map((size, sizeIndex) => (
                <th
                  key={sizeIndex}
                  style={{ textAlign: "center", width: inputDispatchField }}
                >
                  {size.sizeOftype}
                </th>
              ))}
            </tr>
          </thead>
        )}
        <tbody>
          <tr>
            <td style={{ width: "53px" }}></td>
            {selectedSizes.map((size, sizeIndex) => (
              <td key={sizeIndex}>
                <div
                  style={{
                    display: "flex",
                    flexDirection: "row",
                    gap: "6px",
                    alignItems: "center",
                    justifyContent: "center",
                  }}
                >
                  <input
                    type="text"
                    value={
                      (row.sizes &&
                        row.sizes[sizeIndex] &&
                        row.sizes[sizeIndex].awSpec) ||
                      ""
                    }
                    onChange={(e) => {
                      this.handleInputChange1(
                        index,
                        sizeIndex,
                        "awSpec",
                        e.target.value
                      ),
                        this.updateMeasurementChat();
                    }}
                    style={{
                      width: "55px",
                      padding: "6px",
                      boxSizing: "border-box",
                    }}
                    placeholder="AW Spec"
                  />
                  <input
                    type="number"
                    value={
                      (row.sizes &&
                        row.sizes[sizeIndex] &&
                        row.sizes[sizeIndex].bwSpec) ||
                      ""
                    }
                    onChange={(e) =>
                      this.handleInputChange1(
                        index,
                        sizeIndex,
                        "bwSpec",
                        e.target.value
                      )
                    }
                    style={{
                      width: "55px",
                      padding: "6px",
                      boxSizing: "border-box",
                    }}
                    placeholder="BW Spec"
                  />
                  {isDispatch && (
                    <React.Fragment>
                      <input
                        type="number"
                        value={
                          (row.sizes &&
                            row.sizes[sizeIndex] &&
                            row.sizes[sizeIndex].awQA) ||
                          ""
                        }
                        onChange={(e) =>
                          this.handleInputChange1(
                            index,
                            sizeIndex,
                            "awQA",
                            e.target.value
                          )
                        }
                        style={{
                          width: "50px",
                          padding: "6px",
                          boxSizing: "border-box",
                        }}
                        placeholder="AW QA"
                      />
                      <input
                        type="number"
                        value={
                          (row.sizes &&
                            row.sizes[sizeIndex] &&
                            row.sizes[sizeIndex].bwQA) ||
                          ""
                        }
                        onChange={(e) =>
                          this.handleInputChange1(
                            index,
                            sizeIndex,
                            "bwQA",
                            e.target.value
                          )
                        }
                        style={{
                          width: "50px",
                          padding: "6px",
                          boxSizing: "border-box",
                        }}
                        placeholder="BW QA"
                      />
                    </React.Fragment>
                  )}
                </div>
              </td>
            ))}
          </tr>
        </tbody>
      </table>
      //</div>
    );
  };

  // SizeTable1 = ({ row, index, handleSizeChange }) => {
  //   const { state } = this.props.location;
  //   const header = state ? state.header : "Default Header";
  //   const isDispatch = header === "Dispatch ";
  //   const inputDispatchField = isDispatch ? "200px" : "";

  //   return (
  //     <table
  //       style={{
  //         // tableLayout: "fixed",
  //         width: "100%",
  //         borderSpacing: "0px",
  //         borderCollapse: "separate",
  //         backgroundColor: "white",
  //         marginBottom: index === 0 ? "16px" : "0px",
  //       }}
  //     >
  //       {index === 0 && (
  //         <thead>
  //           <tr>
  //           {row.sizes.map((size, sizeIndex) => (
  //             <th
  //               key={sizeIndex}
  //               style={{ textAlign: "center", width: inputDispatchField }}
  //             >
  //               {size.sizeOftype}
  //             </th>
  //           ))}
  //           </tr>
  //           <tr>
  //           {header !=="Dispatch " &&(
  //             <Fragment>
  //             {this.state.selectedSizes.map((size, sizeIndex) => (
  //             <th>
  //               <div
  //                   className="aw-bw-header"
  //                 >
  //                   <div className="">AW Spec</div>
  //                   <div className="">BW Spec</div>

  //                 </div>
  //             </th>
  //             ))}
  //             </Fragment>
  //           )}
  //           {header === "Dispatch " && (
  //             <Fragment>
  //               {this.state.selectedSizes.map((size, sizeIndex) => (
  //             <th>
  //                <div
  //                   className="aw-bw-dis-header"
  //                 >
  //                   <div className="">AW Spec</div>
  //                   <div className="">AW QA</div>
  //                   <div className="">BW Spec</div>
  //                   <div className="">BW QA</div>

  //                 </div>
  //             </th>
  //               ))}
  //             </Fragment>
  //           )}
  //           </tr>
  //         </thead>
  //       )}

  //       <tbody>
  //         <tr>
  //           {/* <td style={{ width: "53px" }}></td> */}
  //           {row.sizes.map((size, sizeIndex) => (
  //             <td key={sizeIndex}>
  //               <div
  //                 style={{
  //                   display: "flex",
  //                   flexDirection: "row",
  //                   gap: "6px",
  //                   alignItems: "center",
  //                   justifyContent: "center",
  //                 }}
  //               >
  //                 <p
  //                   style={{
  //                     width: "50px",
  //                     padding: "6px",
  //                     // border: "1px solid black",
  //                   }}
  //                 >
  //                   {(row.sizes &&
  //                     row.sizes[sizeIndex] &&
  //                     row.sizes[sizeIndex].awSpec) ||
  //                     "-"}
  //                 </p>
  //                 <p
  //                   style={{
  //                     width: "50px",
  //                     padding: "6px",
  //                     // border: "1px solid black",
  //                   }}
  //                 >
  //                   {(row.sizes &&
  //                     row.sizes[sizeIndex] &&
  //                     row.sizes[sizeIndex].bwSpec) ||
  //                     "-"}
  //                 </p>
  //                 {isDispatch && (
  //                   <React.Fragment>
  //                     <p
  //                       style={{
  //                         width: "50px",
  //                         padding: "6px",
  //                         // border: "1px solid black",
  //                       }}
  //                     >
  //                       {(row.sizes &&
  //                         row.sizes[sizeIndex] &&
  //                         row.sizes[sizeIndex].awQA) ||
  //                         "-"}
  //                     </p>
  //                     <p
  //                       style={{
  //                         width: "50px",
  //                         padding: "6px",
  //                         // border: "1px solid black",
  //                       }}
  //                     >
  //                       {(row.sizes &&
  //                         row.sizes[sizeIndex] &&
  //                         row.sizes[sizeIndex].bwQA) ||
  //                         "-"}
  //                     </p>
  //                   </React.Fragment>
  //                 )}
  //               </div>
  //             </td>
  //           ))}
  //         </tr>
  //       </tbody>
  //     </table>
  //   );
  // }


  SizeTable1 = ({ row, index }) => {
    // Assuming `row.sizes` is an array of size objects
    const sizes = row.sizes || [];
    // console.log(sizes,"si");
    const header = this.props.location.state.header
    // console.log('header:', header, );
    
    return (
      <table
        style={{
          width: "100%",
          borderSpacing: "0",
          borderCollapse: "collapse", // Use collapse for clean borders
          backgroundColor: "white",
          border: "1px solid #000", // Add border to the table
        }}
      >
        <thead>
          <tr>
            <th style={{ border: "1px solid #000", padding: "0px" }}>Size</th>
            <th style={{ border: "1px solid #000", padding: "0px" }}>BW Spec</th>
            <th style={{ border: "1px solid #000", padding: "0px" }}>AW Spec</th>
            {header === "Dispatch " && (
              <Fragment>
            <th style={{ border: "1px solid #000", padding: "0px" }}>BWQA</th>
            <th style={{ border: "1px solid #000", padding: "0px" }}>AWQA</th>
            </Fragment>
            )}
          </tr>
        </thead>
        <tbody>
          {sizes.map((size, sizeIndex) => (
            <tr key={sizeIndex}>
              <td style={{ border: "1px solid #000", padding: "0px" }}>{size.sizeOftype || "-"}</td>
              <td style={{ border: "1px solid #000", padding: "0px" }}>{size.bwSpec || "-"}</td>
              <td style={{ border: "1px solid #000", padding: "0px" }}>{size.awSpec}</td>
              {header === "Dispatch " && (
              <Fragment>
                  <td style={{ border: "1px solid #000", padding: "0px" }}>{size.bwQA || "-"}</td>
                  <td style={{ border: "1px solid #000", padding: "0px" }}>{size.awQA || "-"}</td>
            </Fragment>
            )}
            </tr>
          ))}
        </tbody>
      </table>
    );
  }



  // SizeTable1 = ({ row, index }) => {
  //   // Assuming `row.sizes` is an array of size objects
  //   const sizes = row.sizes || [];
  //   // // console.log(sizes,"si");
  //   // const header = this.props.location.state.header
  //   // console.log('header:', header, );
  //   const { state } = this.props.location;
  //   const header = state ? state.header : "Default Header";
  //   const isDispatch = header === "Dispatch ";
  //   const inputDispatchField = isDispatch ? "200px" : "";
    
  //    return (
  //      <table
  //        style={{
  //         // tableLayout: "fixed",
  //          width: "100%",
  //         borderSpacing: "0px",
  //         borderCollapse: "separate",
  //         backgroundColor: "white",
  //         marginBottom: index === 0 ? "16px" : "0px",
  //         border: "1px solid #000", // Add border to the table
  //        }}
  //      >
  //        {index === 0 && (
  //         <thead>
  //           <tr>
  //           {row.sizes.map((size, sizeIndex) => (
  //             <th
  //               key={sizeIndex}
  //               style={{ textAlign: "center", width: inputDispatchField }}
  //             >
  //               {size.sizeOftype}
  //             </th>
  //           ))}
  //           </tr>
  //           <tr>
  //           {header !=="Dispatch " &&(
  //             <Fragment>
  //             {this.state.selectedSizes.map((size, sizeIndex) => (
  //             <th>
  //               <div
  //                   className="aw-bw-header"
  //                 >
  //                   <div className="">AW Spec</div>
  //                   <div className="">BW Spec</div>

  //                 </div>
  //             </th>
  //             ))}
  //             </Fragment>
  //              )}
  //           {header === "Dispatch " && (
  //              <Fragment>
  //              {this.state.selectedSizes.map((size, sizeIndex) => (
  //            <th>
  //               <div
  //                  className="aw-bw-dis-header"
  //                >
  //                  <div className="">AW Spec</div>
  //                  <div className="">AW QA</div>
  //                  <div className="">BW Spec</div>
  //                  <div className="">BW QA</div>

  //                </div>
  //            </th>
  //              ))}
  //            </Fragment>
  //            )}
  //            </tr>
  //         </thead>
  //       )}

  //       <tbody>
  //         <tr>
  //           {/* <td style={{ width: "53px" }}></td> */}
  //           {row.sizes.map((size, sizeIndex) => (
  //             <td key={sizeIndex}>
  //               <div
  //                 style={{
  //                   display: "flex",
  //                   flexDirection: "row",
  //                   gap: "6px",
  //                   alignItems: "center",
  //                   justifyContent: "center",
  //                 }}
  //               >
  //                 <p
  //                   style={{
  //                     width: "50px",
  //                     padding: "6px",
  //                     // border: "1px solid black",
  //                   }}
  //                 >
  //                   {(row.sizes &&
  //                     row.sizes[sizeIndex] &&
  //                     row.sizes[sizeIndex].awSpec) ||
  //                     "-"}
  //                 </p>
  //                 <p
  //                   style={{
  //                     width: "50px",
  //                     padding: "6px",
  //                     // border: "1px solid black",
  //                   }}
  //                 >
  //                   {(row.sizes &&
  //                     row.sizes[sizeIndex] &&
  //                     row.sizes[sizeIndex].bwSpec) ||
  //                     "-"}
  //                 </p>
  //                 {isDispatch && (
  //                   <React.Fragment>
  //                     <p
  //                       style={{
  //                         width: "50px",
  //                         padding: "6px",
  //                         // border: "1px solid black",
  //                       }}
  //                     >
  //                       {(row.sizes &&
  //                         row.sizes[sizeIndex] &&
  //                         row.sizes[sizeIndex].awQA) ||
  //                         "-"}
  //                     </p>
  //                     <p
  //                       style={{
  //                         width: "50px",
  //                         padding: "6px",
  //                         // border: "1px solid black",
  //                       }}
  //                     >
  //                       {(row.sizes &&
  //                         row.sizes[sizeIndex] &&
  //                         row.sizes[sizeIndex].bwQA) ||
  //                         "-"}
  //                     </p>
  //                   </React.Fragment>
  //                 )}
  //               </div>
  //             </td>
  //           ))}
  //         </tr>
          
  //        </tbody>
  //      </table>
  //    );
  // }

  splitTableData(data, sizesPerTable) {
    let tables = [];
    let maxSizes = Math.max(...data.map((row) => row.sizes.length));
    for (let i = 0; i < maxSizes; i += sizesPerTable) {
      let table = data
        .map((row) => ({
          code: row.code,
          description: row.placeofMeasurement,
          tolMinus: row.tolMinus,
          tolPlus: row.tolPlus,
          sizes: row.sizes.slice(i, i + sizesPerTable), // Slicing sizes per table
          comments: row.comments,
          actions: row.actions,
        }))
        .filter((row) => row.sizes.length > 0); // Exclude empty size rows
      tables.push(table);
    }
    return tables;
  }

  renderTables = () => {
    const { measurements1 } = this.state;
    const { state } = this.props.location;
    const header = state ? state.header : "Default Header";
    const isDispatch = header === "Dispatch ";
    const dispatch = isDispatch ? 2 : 4;
    const sizesPerTable = dispatch; // Adjust the number of sizes per table
    const splitData = this.splitTableData(measurements1, sizesPerTable);
  
    return measurements1.map((tableData, tableIndex) => (
      <div key={tableIndex} style={{ marginBottom: "20px" }}>
        <table
          style={{
            width: "100%",
            borderSpacing: "0",
            borderCollapse: "collapse", // Use collapse for clean borders
            borderRadius: "6px",
            overflow: "auto",
            backgroundColor: "white",
            border: "1px solid #000", // Add border to the table
          }}
        >
          <thead>
            <tr>
              <th style={{ width: "61px", border: "1px solid #000", padding: "8px" }}>Code</th>
              <th style={{ width: "81px", border: "1px solid #000", padding: "8px" }}>Description</th>
              <th style={{ width: "46px", border: "1px solid #000", padding: "8px" }}>TOL (-)</th>
              <th style={{ width: "46px", border: "1px solid #000", padding: "8px" }}>TOL (+)</th>
              <th colSpan={6} style={{ width: "auto", height: "30px", border: "1px solid #000", padding: "8px" }}>
                {isDispatch
                  ? "Size & BW, AW"
                  : isDispatch === false
                  ? "Size & AW Spec, BW Spec"
                  : "Size"}
              </th>
              <th style={{ width: "94px", border: "1px solid #000", padding: "8px" }}>Comments</th>
              {header === "Dispatch " &&(
                <th style={{ width: "94px", border: "1px solid #000", padding: "8px" }}>QA/Tech Comments</th>
              )}
            </tr>
          </thead>
          <tbody>
           
              <tr key={tableIndex}>
                <td style={{ border: "1px solid #000", padding: "8px" }}>{tableData.code}</td>
                <td style={{ border: "1px solid #000", padding: "8px" }}>{tableData.placeofMeasurement}</td>
                <td style={{ border: "1px solid #000", padding: "8px" }}>{tableData.tolMinus}</td>
                <td style={{ border: "1px solid #000", padding: "8px" }}>{tableData.tolPlus}</td>
                <td colSpan={6} style={{ border: "1px solid #000", padding: "0" }}>
                  {/* Render sizes dynamically for each table */}
                  <this.SizeTable1 row={tableData} index={tableIndex} />
                </td>
                <td style={{ border: "1px solid #000", padding: "8px" }}>{tableData.comments}</td>
                {header === "Dispatch " &&(
                <td style={{ border: "1px solid #000", padding: "8px" }}>{tableData.dispatchComments}</td>
                )}
              </tr>
           
          </tbody>
        </table>
      </div>
    ));
  };

  downloadExcel = (id,value) => {
    SampleServices.downloadExcel(id,this.props.location.state.header.toLowerCase().trim());
  }


  handleRowChange = (field, value, index) => {
    // Create a copy of the current measurements1 array
    const updatedMeasurements = [...this.state.measurements1];
  
    // Update the specific row's field
    updatedMeasurements[index][field] = value;
  
    // Update the state with the modified measurements1 array
    this.setState({ measurements1: updatedMeasurements });
  };


   handleBackNavigation = () => {
    confirmAlert({
      customUI: ({ onClose }) => (
        <div className="p-5 text-center">
          <button
            onClick={onClose}
            className="close"
            style={{ position: "absolute", right: "40px", top: "15px" }}
          >
            X
          </button>
          <h2>Are you sure you want to leave</h2>
          <p>Make sure your changes are saved</p>
          <button
            type="button"
            className="primary"
            style={{ width: "20%", marginRight: "10px" }}
            onClick={() => {
              onClose();
              this.navigateBack();
            }}
          >
            Yes
          </button>
          <button type="button" className="primary" style={{ width: "20%" }} onClick={onClose}>
            No
          </button>
        </div>
      ),
      closeOnClickOutside: false,
    });
  };
  
   navigateBack = () => {
    const state = this.props.history.location.state;
    const route = state && state.route; // Avoids optional chaining
  
    if (route !== undefined) {
      this.props.history.push(`/${route}`, {
        [route.toLowerCase()]: state[route.toLowerCase()] || {},
      });
    } else {
      this.props.history.goBack();
    }
  };


  handleSRValueSelect = (selectedOption) => {
    if (selectedOption) {
      this.setState({
        srValue: selectedOption.label,     // just the label to send in the api
        srValueObj: selectedOption,        // entire option object 
      });
    } else {
      this.setState({
        srValue: "",
        srValueObj: null,
      });
    }
  };


  // getSampleRequestList = (inputValue) => {
  //   // Optional: You can debounce this call if needed
  //   if (!inputValue) return;
  
  //   SampleServices.getSampleReqNo(inputValue)
  //     .then((response) => {
  //       if (response.status === 200) {
  //         this.setState({
  //           srList: response.text.data, 
  //         });
  //       }
  //     })
  //     .catch((error) => {
  //       console.error("Failed to fetch sample request numbers:", error);
  //     });
  // }

  getSampleRequestList = (inputValue) => {
    if (inputValue == null) return;
  
    if (inputValue === "") {
      
      this.setState({ srList: [] });
    }
  
    SampleServices.getSampleReqNo(inputValue)
      .then((response) => {
        if (response.status === 200) {
          this.setState({
            srList: response.text.data,
          });
        }
      })
      .catch((error) => {
        console.error("Failed to fetch sample request numbers:", error);
      });
  };
  
  

  render() {
    const { selectedSizes } = this.state;
    const { isModalOpen, srValue, isOpen1 } = this.state;
    const { state } = this.props.location;
    const header = state ? state.header : "Default Header";
    //console.log(header,"header",this.props.location.state.header)
    const isDispatch = header === "Dispatch ";
    const inputDispatchField = isDispatch ? "200px" : "";
    //console.log(this.state.selectedMeasurements.length,"selected",this.state.additionalData.length,"add")

    return (
      <div className="right-section ">
        <div className="row nopadding">
          <div
            className="col-md-12 px-0 py-2 "
            style={{
              display: "flex",
              justifyContent: "space-between",
              alignItems: "center",
            }}
          >
            {/* Back Button */}
            <div
              className="col-md-4 nopadding text-left"
              style={{ display: "flex", alignItems: "center" }}
            >
              <span
                className="p-2 cursor-hover"
                // onClick={() => {
                //   const route = this.props.history.location.state.route;
                //   route
                //     ? this.props.history.push(`/${route}`, {
                //         [`${route.toLowerCase()}`]: {
                //           ...this.props.history.location.state[
                //             `${route.toLowerCase()}`
                //           ],
                //         },
                //       })
                //     : this.props.history.goBack();
                // }}
                onClick={this.handleBackNavigation}
              >
                <img width="20px" src={leftArrowImage} alt="Back" />
              </span>
              <span style={{ fontWeight: "bold" }}>
                MEASUREMENT CHART ({header.toUpperCase().trim()})
              </span>
            </div>

            {/* Buttons */}
            <div
              className="col-md-4"
              style={{
                display: "flex",
                justifyContent: "flex-end",
                gap: "10px",
              }}
            >
              <div>
                {/* Print Button */}
                {/* <ReactToPrint
                  trigger={() => (
                    <button
                      style={{
                        backgroundColor: "white",
                        color: "#009688",
                        border: "1px solid #009688",
                        borderRadius: "5px",
                        padding: "4px 14px",
                        cursor: "pointer",
                        display: "flex",
                        alignItems: "center",
                        gap: "5px",
                      }}
                    >
                      <i className="fa fa-print" /> Print
                    </button>
                  )}
                  content={() => this.componentRef} // Use .current for ref
                /> */}

                {/* Hidden Table (only visible for print) */}
                <div
                  ref={(el) => (this.componentRef = el)}
                  style={{ display: "none" }}
                  className="hidden-print"
                >
                  {this.renderTables()}
                </div>

                {/* CSS to show only for printing */}
                <style>
  {`
    @media print {
    /* Your previous style */
      .hidden-print {
        display: block !important;
      }
      table {
        border: 1px solid #000 !important;
      }
      th, td {
        border: 1px solid #000 !important;
        padding: 8px !important;
      }
      .print-table-container {
        page-break-inside: avoid; /* Prevent table from splitting across pages */
      }
    }
  `}
</style>
              </div>
              {/* <button
                style={{
                  padding: "4px 14px",
                  backgroundColor: "#009688",
                  color: "white",
                  border: "none",
                  borderRadius: "4px",
                  cursor: "pointer",
                }}
                onClick={()=>this.downloadExcel(this.state._id)}
                disabled={this.state.action === "view"}
              >
                Excel
              </button> */}
              <button
              style={{
                backgroundColor: "white",
                color: "#009688",
                border: "1px solid #009688",
                borderRadius: "5px",
                padding: "4px 14px",
                cursor: "pointer",
                display: "flex",
                alignItems: "center",
                gap: "5px",
              }}
              onClick={() => this.downloadExcel(this.state._id)}
              disabled={this.state.action === "view"}
            >
              <i className="fa fa-file-excel-o" /> Excel
            </button>

              <button
                style={{
                  padding: "4px 14px",
                  backgroundColor: "#009688",
                  color: "white",
                  border: "none",
                  borderRadius: "4px",
                  cursor: "pointer",
                }}
                onClick={this.saveChart}
                disabled={this.state.action === "view"}
              >
                Save
              </button>
              {header !== "Dispatch " && (
                <button
                  style={{
                    padding: "4px 14px",
                    backgroundColor: "#009688",
                    color: "white",
                    border: "none",
                    borderRadius: "4px",
                    cursor: "pointer",
                  }}
                  onClick={this.openModal}
                  disabled={
                    header === "Dispatch " || this.state.action === "view"
                  }
                >
                  Duplicate
                </button>
              )}
            </div>
            <CustomModal
              isOpen={isModalOpen}
              onClose={this.closeModal}
              onSave={this.duplicateMC}
              srValue={srValue}
              srValueObj={this.state.srValueObj}
              sampleRequestList={this.state.srList}
              getSampleRequestList={this.getSampleRequestList}
              handleSRValueSelect={this.handleSRValueSelect}

              // handleInputChange={this.handleDupInputChange}
            />
          </div>

          {/* <div className="col-md-12 text-center">
            <div className="row no-padding">
              {/* Static headings with dynamic API data 
              <div className="col-md-2">
                <div className="">
                  <label>Magnum Style No</label>
                  <span>{this.state.Magnumstyleno || ""}</span>
                </div>
              </div>

              <div className="col-md-2">
                <div className="">
                  <label>Magnum Style Name</label>
                  <span className="wrap-text">
                    {this.state.Magnumstylename || ""}
                  </span>
                </div>
              </div>


              <div className="col-md-2">
                <div className="">
                  <label>Customer / Dept</label>
                  <span className="wrap-text">{this.state.CustomerDept || ""}</span>
                </div>
              </div>

              <div className="col-md-1">
                <div className="">
                  <label>Cus Ref.No</label>
                  <span className="wrap-text">{this.state.Cusrefno || ""}</span>
                </div>
              </div>

              <div className="col-md-1">
                <div className="">
                  <label>Garment Type</label>
                  <span>{_.capitalize(this.state.GarmentType || "")}</span>
                </div>
              </div>

              <div className="col-md-1.5" style={{paddingLeft:"20px"}}>
                <div className="">
                  <label>Source of Request</label>
                  <span>{_.capitalize(this.state.typeOfRequest || "")}</span>
                </div>
              </div>

              <div className="col-md-2">
                <div className="">
                  <label>Sample type</label>
                  <span>{this.state.SampleType || ""}</span>
                </div>
              </div>

              <div className="col-md-1">
                <div className="">
                  <label>SR No</label>
                  <span className="wrap-text">{this.state.SourceOfRequest || ""}</span>
                </div>
              </div>
            </div>
          </div> */}


{/* 
<div
  style={{
    display: "flex",
    flexDirection: "row",
    overflowX: "auto",
    whiteSpace: "nowrap",
    padding: "10px 0",
    marginLeft:"34px",
    textAlign:"center",
    marginBottom:"10px"
  }}
>
  <div style={{ marginRight: "30px" }}>
    <label>Magnum Style No</label>
    <span>{this.state.Magnumstyleno || ""}</span>
  </div>

  <div style={{ marginRight: "30px" }}>
    <label>Magnum Style Name</label>
    <span>{this.state.Magnumstylename || ""}</span>
  </div>

  <div style={{ marginRight: "30px" }}>
    <label>Customer / Dept</label>
    <span>{this.state.CustomerDept || ""}</span>
  </div>

  <div style={{ marginRight: "30px" }}>
    <label>Cus Ref.No</label>
    <span>{this.state.Cusrefno || ""}</span>
  </div>

  <div style={{ marginRight: "30px" }}>
    <label>Garment Type</label>
    <span>{_.capitalize(this.state.GarmentType || "")}</span>
  </div>

  <div style={{ marginRight: "30px" }}>
    <label>Source of Request</label>
    <span>{_.capitalize(this.state.typeOfRequest || "")}</span>
  </div>

  <div style={{ marginRight: "30px" }}>
    <label>Sample type</label>
    <span>{this.state.SampleType || ""}</span>
  </div>

  <div style={{ marginRight: "30px" }}>
    <label>SR No</label>
    <span>{this.state.SourceOfRequest || ""}</span>
  </div>
</div> */}



{/* <div
  style={{
    display: "flex",
    flexDirection: "row",
    overflowX: "auto",
    whiteSpace: "nowrap",
    padding: "10px 0",
    marginLeft: "34px",
    textAlign: "center",
    marginBottom: "10px",
  }}
>
  <div style={{ marginRight: "30px", minWidth: "130px" }}>
    <label>Magnum Style No</label>
    <span style={{ whiteSpace: "normal", wordBreak: "break-word" }}>
      {this.state.Magnumstyleno || ""}
    </span>
  </div>

  <div style={{ marginRight: "30px", minWidth: "130px" }}>
    <label>Magnum Style Name</label>
    <span style={{ whiteSpace: "normal", wordBreak: "break-word" }}>
      {this.state.Magnumstylename || ""}
    </span>
  </div>

  <div style={{ marginRight: "30px", minWidth: "130px" }}>
    <label>Customer / Dept</label>
    <span style={{ whiteSpace: "normal", wordBreak: "break-word" }}>
      {this.state.CustomerDept || ""}
    </span>
  </div>

  <div style={{ marginRight: "30px", minWidth: "130px" }}>
    <label>Cus Ref.No</label>
    <span style={{ whiteSpace: "normal", wordBreak: "break-word" }}>
      {this.state.Cusrefno || ""}
    </span>
  </div>

  <div style={{ marginRight: "30px", minWidth: "130px" }}>
    <label>Garment Type</label>
    <span style={{ whiteSpace: "normal", wordBreak: "break-word" }}>
      {_.capitalize(this.state.GarmentType || "")}
    </span>
  </div>

  <div style={{ marginRight: "30px", minWidth: "130px" }}>
    <label>Source of Request</label>
    <span style={{ whiteSpace: "normal", wordBreak: "break-word" }}>
      {_.capitalize(this.state.typeOfRequest || "")}
    </span>
  </div>

  <div style={{ marginRight: "30px", minWidth: "130px" }}>
    <label>Sample type</label>
    <span style={{ whiteSpace: "normal", wordBreak: "break-word" }}>
      {this.state.SampleType || ""}
    </span>
  </div>

  <div style={{ marginRight: "30px", minWidth: "130px" }}>
    <label>SR No</label>
    <span style={{ whiteSpace: "normal", wordBreak: "break-word" }}>
      {this.state.SourceOfRequest || ""}
    </span>
  </div>
</div> */}


{/* <div
  style={{
    display: "flex",
    justifyContent: "space-evenly", // even spacing between items
    flexWrap: "nowrap",
    // overflowX: "auto",
    padding: "10px 0",
    marginLeft: "34px",
    textAlign: "center",
    marginBottom: "10px",
  }}
>
  {[
    { label: "Magnum Style No", value: this.state.Magnumstyleno },
    { label: "Magnum Style Name", value: this.state.Magnumstylename },
    { label: "Customer / Dept", value: this.state.CustomerDept },
    { label: "Cus Ref.No", value: this.state.Cusrefno },
    { label: "Garment Type", value: _.capitalize(this.state.GarmentType || "") },
    { label: "Source of Request", value: _.capitalize(this.state.typeOfRequest || "") },
    { label: "Sample type", value: this.state.SampleType },
    { label: "SR No", value: this.state.SourceOfRequest },
  ].map((item, index) => (
    <div
      key={index}
      style={{
        flex: "0 0 20%", // fixed width for even spacing, scrolls when needed
        margin: "0 10px",
      }}
    >
      <label>{item.label}</label>
      <span style={{ whiteSpace: "normal", wordBreak: "break-word" }}>
        {item.value || ""}
      </span>
    </div>
  ))}
</div> */}


<div
  style={{
    display: "flex",
    flexDirection: "row",
    justifyContent: "space-between", // even space between items
    alignItems: "flex-start",
    width: "100%",
    padding: "10px 34px",
    boxSizing: "border-box",
    textAlign: "center",
  }}
>
  {[
    { label: "Magnum Style No", value: this.state.Magnumstyleno },
    { label: "Magnum Style Name", value: this.state.Magnumstylename },
    { label: "Customer / Dept", value: this.state.CustomerDept },
    { label: "Cus Ref.No", value: this.state.Cusrefno },
    { label: "Garment Type", value: _.capitalize(this.state.GarmentType || "") },
    { label: "Source of Request", value: _.capitalize(this.state.typeOfRequest || "") },
    { label: "Sample type", value: this.state.SampleType },
    { label: "SR No", value: this.state.SourceOfRequest },
  ].map((item, index) => (
    <div
      key={index}
      style={{
        flex: 1,                    // Evenly distribute space
        padding: "0 10px",          // Optional spacing between items
        minWidth: 0,                // Prevent overflow
        wordBreak: "break-word",    // Wrap long words
      }}
    >
      <label>{item.label}</label>
      
      <span style={{ whiteSpace: "normal" }}>
        {item.value || ""}
      </span>
    </div>
  ))}
</div>



          <div
            className=""
            style={{
              width: "96%",
              // height: "99px",
              display: "flex",
              alignItems: "flex-start",
              boxSizing: "border-box",
              boxShadow: "0px 0px 20px 0px rgba(0, 0, 0, 0.1)",
              marginLeft: "32px",
              marginBottom: "5px",
              paddingBottom:"8px"
            }}
          >
            <div className="shrinkLabel">
              <label className="col-form-label font-weight-bold">
                Shrinkage Percentage:
              </label>
            </div>
            <div
              style={{
                width: "80%",
                display: "flex",
                gap: "15px",
                alignItems: "center",
                // height: "78px",
              }}
            >
              <div
                style={{ display: "flex", flexDirection: "column", gap: "5px" }}
              >
                <label className="form-label">Length(%)</label>
                <input
                  type="text"
                  placeholder="Length (%)"
                  name="length"
                  value={this.state.shrinkagePercentage.length || ""}
                  onChange={this.handleShrinkageChange}
                  disabled={
                    header === "Dispatch " || this.state.action === "view"
                  }
                  style={{
                    width: "120px",
                    padding: "6px 10px",
                    border: "1px solid",
                    borderRadius: "4px",
                    boxSizing: "border-box",
                    fontSize: "12px",
                    // height: "32px",
                  }}
                />
              </div>
              <div
                style={{ display: "flex", flexDirection: "column", gap: "5px" }}
              >
                <label className="form-label">Width(%)</label>
                <input
                  type="text"
                  placeholder="Width (%)"
                  name="width"
                  value={this.state.shrinkagePercentage.width || ""}
                  onChange={this.handleShrinkageChange}
                  disabled={
                    header === "Dispatch " || this.state.action === "view"
                  }
                  style={{
                    width: "120px",
                    padding: "6px 10px",
                    border: "1px solid",
                    borderRadius: "4px",
                    boxSizing: "border-box",
                    fontSize: "12px",
                    // height: "32px",
                  }}
                />
              </div>
            </div>
          </div>
          {/* <this.renderTables  /> */}

          <div className="table-container1">
            <table className="tableWrapper leftBody">
              <thead>
                <tr>
                  <th scope="col" style={{ fontSize: "14px", padding: "0px" }}>
                    Code
                  </th>
                  <th scope="col" style={{ fontSize: "14px", padding: "0px" }}>
                    Description
                  </th>
                  <th style={{fontSize:"14px"}}>Shrinkage</th>
                  <th style={{ fontSize: "14px",paddingRight:"5px"  }}>TOL (-)</th>
                  <th style={{ fontSize: "14px",  }}>TOL (+)</th>
                </tr>
                <tr height="49px"></tr>
              </thead>
              <tbody>
                {this.state.measurements1 &&
                this.state.measurements1.length > 0 ? (
                  this.state.measurements1.map((row, index) => (
                    <tr
                      key={index}
                      style={{
                        backgroundColor: index % 2 == 0 ? "#F2F2EF" : "white",
                      }}
                    >
                      <td className="p-0" style={{ fontSize: "12px", fontWeight: "400px" }}>
                        {row.code}
                      </td>
                      <td   className=" h-54px" style={{  fontSize: "12px", fontWeight: "400px", maxWidth: "330px", wordWrap: "break-word", padding:"0px 9px", textAlign:"left" }}>
                        {row.placeofMeasurement}
                      </td>
                      <td className="" style={{textAlign:"left",padding:"5px 5px"}}>
                      <select
                        className="w-50-p-4"
                        value={row.shrinkageType}
                        onChange={(e) => {this.handleRowChange("shrinkageType", e.target.value, index)
                                          this.updateMeasurementChat();
                        }}
                        disabled={
                          header === "Dispatch " ||
                          this.state.action === "view"
                        }
                        style={{
                          border: row.shrinkageType ? "1px solid #ddd" : "1px solid red", // Red border if empty
                        }}
                      >
                        <option value="" >-select-</option>
                        {this.state.SHRINKAGETYPEOPTIONS && this.state.SHRINKAGETYPEOPTIONS.map((option, idx) => (
                          <option key={idx} value={option.value}>{option.label}</option>
                        ))}
                      </select>
                      </td>
                      <td style={{ padding: "5px 5px" }}>
                        <input
                          type="text"
                          value={row.tolMinus}
                          onChange={(e) =>
                            this.handleInputChange(
                              index,
                              "tolMinus",
                              e.target.value
                            )
                          }
                          style={{
                            width: "55px",
                            padding: "6px",
                            boxSizing: "border-box",
                            borderRadius: "4px",
                            border: "1px solid",
                            fontSize: "12px",
                          }}
                          disabled={
                            header === "Dispatch " ||
                            this.state.action === "view"
                          }
                        />
                      </td>
                      <td style={{ padding: "0px" }}>
                        <input
                          type="text"
                          value={row.tolPlus}
                          onChange={(e) =>
                            this.handleInputChange(
                              index,
                              "tolPlus",
                              e.target.value
                            )
                          }
                          style={{
                            width: "55px",
                            padding: "6px",
                            boxSizing: "border-box",
                            borderRadius: "4px",
                            border: "1px solid",
                            fontSize: "12px",
                          }}
                          disabled={
                            header === "Dispatch " ||
                            this.state.action === "view"
                          }
                        />
                      </td>
                    </tr>
                  ))
                ) : (
                  <tr>
                    <td colSpan="2">No Data Available</td>
                  </tr>
                )}
              </tbody>
            </table>
            <table className="tableWrapper sizesBody">
              <thead>
                <tr>
                  <th></th>
                  <th
                    colspan="50%"
                    style={{
                      fontSize: "14px",
                      padding: "0px",
                      position: "relative",
                    }}
                  >
                    <div
                      style={{
                        position: "sticky",
                        left: header === "Dispatch " ? "33%"  :  "20%",
                        width: "200px",
                      }}
                    >
                      {isDispatch
                        ? "Size & BW, AW"
                        : isDispatch === false
                        ? "Size & AW Spec, BW Spec"
                        : "Size"}
                    </div>
                  </th>
                </tr>
                <tr>
                  <th style={{ width: "53px", position: "relative" }}>
                    <button
                      className="dropdownButton"
                      onClick={this.toggleDropdown}
                      style={{
                        padding: "1px 5px",
                        borderColor: isOpen1 ? "lightcoral" : "#009688",
                        marginBottom: "5px",
                      }}
                      ref={this.state.buttonRef2}
                      disabled={
                        header === "Dispatch " || this.state.action === "view" || this.state.measurements1.length<1
                      }
                    >
                      <i
                        className={`fa ${isOpen1 ? "fa-close" : "fa-plus"}`}
                        style={{
                          fontSize: "12px",
                          color: isOpen1 ? "rgba(244, 67, 54, 1)" : "#009688",
                        }}
                      />
                      {/* Add icon */}
                    </button>

                    {this.state.showDropdown && (
                      <ul
                        style={{
                          position: "absolute",
                          top: "100%",
                          left: 0,
                          listStyleType: "none",
                          padding: "8px",
                          backgroundColor: "white",
                          border: "1px solid #ddd",
                          borderRadius: "4px",
                          boxShadow: "0 4px 6px rgba(0, 0, 0, 0.1)",
                          maxHeight: this.state.measurements1.length >=3 ?"230px" : "127px", // Set a fixed height for scrolling
                          overflowY: "auto", // Enable vertical scrolling
                          overflowX: "hidden", // Disable horizontal scrolling
                          zIndex: 1000,
                        }}
                        ref={this.state.dropdownRef1}
                      >
                        {this.state.availableSizes.map((size) => (
                          <li
                            key={size}
                            style={{
                              padding: "6px 12px",
                              borderBottom: "1px solid #f0f0f0",
                              display: "flex",
                              alignItems: "center",
                            }}
                          >
                            <input
                              type="checkbox"
                              checked={this.state.selectedSizes.some(
                                (s) => s.sizeOftype === size
                              )}
                              onChange={() => this.handleAddSize(size)}
                              style={{
                                marginRight: "8px",
                                position: "static", // Reset position
                                left: "auto", // Reset left positioning
                                opacity: 1,
                                cursor: "pointer",
                              }}
                            />
                            {size}
                          </li>
                        ))}
                      </ul>
                    )}
                  </th>
                  {selectedSizes.map((size, sizeIndex) => (
                    <th
                      key={sizeIndex}
                      style={{
                        textAlign: "center",
                        width: inputDispatchField,
                        fontSize: "14px",
                      }}
                    >
                      {size.sizeOftype}
                    </th>
                  ))}
                  <th style={{ fontSize: "14px", padding: "0px" }}>
        {header !== "Dispatch " ? "Comments" : "Pattern Comments"}
      </th>
      {header === "Dispatch " && (
        <th style={{ fontSize: "14px", padding: "0px", textAlign: "center", fontWeight: "600" }}>
          QA/Tech Comments
        </th>
      )}
                </tr>
                {header !== "Dispatch " && (
                  <tr>
                    <th></th>
                    {selectedSizes.map((size, sizeIndex) => (
                  <th>
                    <div
                    // style={{
                    //   display: "flex",
                    //   flexDirection: "row",
                    //   gap: "6px",
                    //   alignItems: "center",
                    //   justifyContent: "center",
                    //   padding: "10px",
                    // }}
                    className="aw-bw-header"
                  >
                    <div className="">AW Spec</div>
                    <div className="">BW Spec</div>

                  </div>
                                  
                  </th>
                    ))}
                </tr>
                )}
                {header === "Dispatch " && (
                  <tr>
                    <th></th>
                  
                    {selectedSizes.map((size, sizeIndex) => (
                  <th>
                    <div
                    // style={{
                    //   display: "flex",
                    //   flexDirection: "row",
                    //   gap: "10px",
                    //   alignItems: "center",
                    //   justifyContent: "center",
                    //   padding: "",
                    // }}
                    className="aw-bw-dis-header"
                  >
                    <div className="">AW Spec</div>
                    <div className="">AW QA</div>
                    <div className="">BW Spec</div>
                    <div className="">BW QA</div>

                  </div>
                                  
                  </th>
                    ))}
                </tr>
                )}
              </thead>
              <tbody>
                {this.state.measurements1 &&
                this.state.measurements1.length > 0 ? (
                  this.state.measurements1.map((row, index) => (
                    <tr
                      style={{
                        backgroundColor:
                          this.state.selectedSizes &&
                          this.state.selectedSizes.length > 0
                            ? index % 2 == 0
                              ? "#F2F2EF"
                              : "white"
                            : "white",
                      }}
                    >
                      <td className="hei" style={{ width: "53px", padding:"0px", }}></td>
                      {selectedSizes.map((size, sizeIndex) => {
                        return (
                          <React.Fragment>
                            {header !== "Dispatch " && (
                              <td key={sizeIndex} className="p-0">
                                <div
                                  // style={{
                                  //   display: "flex",
                                  //   flexDirection: "row",
                                  //   gap: "6px",
                                  //   alignItems: "center",
                                  //   justifyContent: "center",
                                  //   padding: "10px",
                                  // }}
                                  className="aw-bw"
                                >
                                  <input
                                    type="text"
                                    value={
                                      (row.sizes &&
                                        row.sizes[sizeIndex] &&
                                        row.sizes[sizeIndex].awSpec) ||
                                      ""
                                    }
                                    onChange={(e) => {
                                      this.handleInputChange1(
                                        index,
                                        sizeIndex,
                                        "awSpec",
                                        e.target.value
                                      ),
                                        this.updateMeasurementChat();
                                    }}
                                    style={{
                                      width: "55px",
                                      padding: "6px",
                                      boxSizing: "border-box",
                                      borderRadius: "4px",
                                      border: "1px solid",
                                      fontSize: "12px",
                                    }}
                                    placeholder="AW Spec"
                                    disabled={
                                      header === "Dispatch " ||
                                      this.state.action === "view"
                                    }
                                    className="sizes-aw"
                                  />
                                  <input
                                    type="text"
                                    value={
                                      (row.sizes &&
                                        row.sizes[sizeIndex] &&
                                        row.sizes[sizeIndex].bwSpec) ||
                                      ""
                                    }
                                    onChange={(e) =>
                                      this.handleInputChange1(
                                        index,
                                        sizeIndex,
                                        "bwSpec",
                                        e.target.value
                                      )
                                    }
                                    style={{
                                      width: "55px",
                                      padding: "6px",
                                      boxSizing: "border-box",
                                      borderRadius: "4px",
                                      border: "1px solid",
                                      fontSize: "12px",
                                    }}
                                    placeholder="BW Spec"
                                    disabled={
                                      header === "Dispatch " ||
                                      this.state.action === "view"
                                    }
                                    className="sizes-aw"
                                  />
                                </div>
                              </td>
                            )}
                            {header === "Dispatch " && (
                              <React.Fragment>
                                <td key={sizeIndex} className="p-0">
                                  <div
                                    // style={{
                                    //   display: "flex",
                                    //   flexDirection: "row",
                                    //   gap: "6px",
                                    //   alignItems: "center",
                                    //   justifyContent: "center",
                                    //   padding: "10px",
                                    // }}
                                    className="aw-bw-dis"
                                  >
                                    <input
                                      type="text"
                                      value={
                                        (row.sizes &&
                                          row.sizes[sizeIndex] &&
                                          row.sizes[sizeIndex].awSpec) ||
                                        ""
                                      }
                                      onChange={(e) => {
                                        this.handleInputChange1(
                                          index,
                                          sizeIndex,
                                          "awSpec",
                                          e.target.value
                                        ),
                                          this.updateMeasurementChat();
                                      }}
                                      style={{
                                        width: "55px",
                                        padding: "6px",
                                        boxSizing: "border-box",
                                        borderRadius: "4px",
                                        border: "1px solid",
                                        fontSize: "12px",
                                      }}
                                      placeholder="AW Spec"
                                      disabled={
                                        header === "Dispatch " ||
                                        this.state.action === "view"
                                      }
                                      className="sizes-aw"
                                    />
                                    <input
                                      type="text"
                                      value={
                                        (row.sizes &&
                                          row.sizes[sizeIndex] &&
                                          row.sizes[sizeIndex].awQA) ||
                                        ""
                                      }
                                      onChange={(e) =>
                                        this.handleInputChange1(
                                          index,
                                          sizeIndex,
                                          "awQA",
                                          e.target.value
                                        )
                                      }
                                      style={{
                                        width: "55px",
                                        padding: "6px",
                                        boxSizing: "border-box",
                                        borderRadius: "4px",
                                        // border: "1px solid",
                                        border: 
                                        row.sizes &&
                                        row.sizes[sizeIndex] &&
                                        row.sizes[sizeIndex].awSpec &&
                                        row.sizes[sizeIndex].awQA &&
                                        parseFloat(row.sizes[sizeIndex].awSpec || 0) ==
                                        parseFloat(row.sizes[sizeIndex].awQA || 0)
                                          ? "2px solid"
                                          : "1px solid", 
                                        fontSize: "12px",
                                      //   borderColor:
                                      //   row.sizes &&
                                      //   row.sizes[sizeIndex] &&
                                      //   row.sizes[sizeIndex].awSpec &&
                                      //   row.sizes[sizeIndex].awQA
                                      //     ? parseFloat(row.sizes[sizeIndex].awSpec || 0) >=
                                      //       parseFloat(row.sizes[sizeIndex].awQA || 0)
                                      //       ? "lightgreen"
                                      //       : "red"
                                      //     : "black", 
                                      // }}
                                      borderColor:
                                        row.sizes &&
                                        row.sizes[sizeIndex] &&
                                        row.sizes[sizeIndex].awSpec &&
                                        row.sizes[sizeIndex].awQA
                                          ? parseFloat(row.sizes[sizeIndex].awSpec || 0) === parseFloat(row.sizes[sizeIndex].awQA || 0)
                                            ? "lightgreen" // ✅ Equal → Light Green
                                            : parseFloat(row.sizes[sizeIndex].awSpec || 0) > parseFloat(row.sizes[sizeIndex].awQA || 0)
                                              ? "blue"       // ✅ Greater → Red
                                              : "red"      // ✅ Less → Blue
                                          : "black", // Default color if values are missing
                                      }}
                                      placeholder="AW QA"
                                      disabled={this.state.action === "view"}
                                      className="sizes-aw"
                                    />
                                    <input
                                      type="text"
                                      value={
                                        (row.sizes &&
                                          row.sizes[sizeIndex] &&
                                          row.sizes[sizeIndex].bwSpec) ||
                                        ""
                                      }
                                      onChange={(e) =>
                                        this.handleInputChange1(
                                          index,
                                          sizeIndex,
                                          "bwSpec",
                                          e.target.value
                                        )
                                      }
                                      style={{
                                        width: "55px",
                                        padding: "6px",
                                        boxSizing: "border-box",
                                        borderRadius: "4px",
                                        border: "1px solid",
                                        fontSize: "12px",
                                      }}
                                      placeholder="BW Spec"
                                      disabled={
                                        header === "Dispatch " ||
                                        this.state.action === "view"
                                      }
                                      className="sizes-aw"
                                    />
                                    <input
                                      type="text"
                                      value={
                                        (row.sizes &&
                                          row.sizes[sizeIndex] &&
                                          row.sizes[sizeIndex].bwQA) ||
                                        ""
                                      }
                                      onChange={(e) =>
                                        this.handleInputChange1(
                                          index,
                                          sizeIndex,
                                          "bwQA",
                                          e.target.value
                                        )
                                      }
                                      style={{
                                        width: "55px",
                                        padding: "6px",
                                        boxSizing: "border-box",
                                        borderRadius: "4px",
                                        // border: "1px solid",
                                        border: 
                                        row.sizes &&
                                        row.sizes[sizeIndex] &&
                                        row.sizes[sizeIndex].bwSpec &&
                                        row.sizes[sizeIndex].bwQA &&
                                        parseFloat(row.sizes[sizeIndex].bwSpec || 0) ==
                                        parseFloat(row.sizes[sizeIndex].bwQA || 0)
                                          ? "2px solid" // ✅ 
                                          : "1px solid", // Default border-radius
                                        fontSize: "12px",
                                        borderColor:
                                          row.sizes &&
                                          row.sizes[sizeIndex] &&
                                          row.sizes[sizeIndex].bwSpec &&
                                          row.sizes[sizeIndex].bwQA
                                            ? parseFloat(row.sizes[sizeIndex].bwSpec || 0) === parseFloat(row.sizes[sizeIndex].bwQA || 0)
                                              ? "lightgreen" // ✅ Equal → Light Green
                                              : parseFloat(row.sizes[sizeIndex].bwSpec || 0) > parseFloat(row.sizes[sizeIndex].bwQA || 0)
                                                ? "blue"       // ✅ Greater → Red
                                                : "red"      // ✅ Less → Blue
                                            : "black", // Default color if values are missing
                                      }}
                                      placeholder="BW QA"
                                      disabled={this.state.action === "view"}
                                      className="sizes-aw"
                                    />
                                  </div>
                                </td>
                              </React.Fragment>
                            )}
                          </React.Fragment>
                        );
                      })}
                      {/* Add Comments column */}
          <td style={{ padding: "5px 5px", fontSize: "12px" }}>
            <input
              value={row.comments}
              onChange={(e) => {
                let trimmedValue = e.target.value.replace(/^\s+/, "");
                this.handleInputChange(index, "comments", trimmedValue);
              }}
              
              maxLength={75}
              style={{ padding: "6px",
                boxSizing: "border-box",
                borderRadius: "4px",
                border: "1px solid",
                fontSize: "12px",
                width:"250px"
               }}
              disabled={this.state.action === "view" || header === "Dispatch "}
              placeholder="Comments"
            />
          </td>
          {header === "Dispatch " && (
            <td style={{ padding: "0px", fontSize: "12px" }}>
              <input
                value={row.dispatchComments}
                onChange={(e) => {
                  let trimmedValue = e.target.value.replace(/^\s+/, "");
                  this.handleInputChange(index, "dispatchComments", trimmedValue);
                }}
                maxLength={75}
                style={{ padding: "6px",
                  boxSizing: "border-box",
                  borderRadius: "4px",
                  border: "1px solid",
                  fontSize: "12px",
                  width:"420px" }}
                disabled={this.state.action === "view"}
                placeholder="Dispatch Comments"
              />
            </td>
          )}
          {header !== "Dispatch " &&(
          <td>
                            <button
                              onClick={() => this.handleDeleteRow(index)}
                              style={{
                                backgroundColor: "rgba(244, 67, 54, 0.1)",
                                color: "rgba(244, 67, 54, 1)",
                                border: "none",
                                borderRadius: "50%",
                                width: "24px",
                                height: "24px",
                                cursor: "pointer",
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "center",
                                fontWeight: "700",
                              }}
                              disabled={this.state.action === "view"}
                            >
                              <i
                                className="fa fa-close"
                                style={{ fontSize: "12px" }}
                              ></i>
                            </button>
                          </td>
          )}
                    </tr>
                  ))
                ) : (
                  <div></div>
                )}
              </tbody>
            </table>
            {/* <table className="tableWrapper rightBody">
              {header !== "Dispatch " ? (
                <React.Fragment>
                  <thead>
                    <tr>
                      <th style={{ fontSize: "14px", padding: "10px" }}>
                        Comments
                      </th>
                    </tr>
                    <tr height="30px"></tr>
                  </thead>
                  <tbody>
                    {this.state.measurements1 &&
                    this.state.measurements1.length > 0 ? (
                      this.state.measurements1.map((row, index) => (
                        <tr
                          key={index}
                          style={{
                            backgroundColor:
                              index % 2 === 0 ? "#F2F2EF" : "white",
                          }}
                        >
                          <td style={{ padding: "10px", fontSize: "12px" }}>
                            {/* <input
                              type="text"
                              value={row.comments}
                              onChange={(e) => {
                                let trimmedValue = e.target.value.replace(/^\s+/, ""); // Remove leading spaces
                                this.handleInputChange(index, "comments", trimmedValue);
                              }}
                              maxLength={75}
                              style={{
                                width: "160px",
                                padding: "6px",
                                boxSizing: "border-box",
                                borderRadius: "4px",
                                border: "1px solid",
                                fontSize: "12px",
                              }}
                              disabled={this.state.action === "view"}
                            /> 
                            <textarea
                              value={row.comments}
                              onChange={(e) => {
                                let trimmedValue = e.target.value.replace(
                                  /^\s+/,
                                  ""
                                ); // Remove leading spaces
                                this.handleInputChange(
                                  index,
                                  "comments",
                                  trimmedValue
                                );
                              }}
                              rows={2}
                              maxLength={75}
                              style={{
                                // width: "160px",
                                padding: "5px",
                                // boxSizing: "border-box",
                                // borderRadius: "4px",
                                // border: "1px solid",
                                // fontSize: "12px",
                              }}
                              disabled={this.state.action === "view"}
                              placeholder="Comments"
                            />
                          </td>
                          <td>
                            <button
                              onClick={() => this.handleDeleteRow(index)}
                              style={{
                                backgroundColor: "rgba(244, 67, 54, 0.1)",
                                color: "rgba(244, 67, 54, 1)",
                                border: "none",
                                borderRadius: "50%",
                                width: "24px",
                                height: "24px",
                                cursor: "pointer",
                                display: "flex",
                                alignItems: "center",
                                justifyContent: "center",
                                fontWeight: "700",
                              }}
                              disabled={this.state.action === "view"}
                            >
                              <i
                                className="fa fa-close"
                                style={{ fontSize: "12px" }}
                              ></i>
                            </button>
                          </td>
                        </tr>
                      ))
                    ) : (
                      <tr>
                        <td
                          colSpan="2"
                          style={{ textAlign: "center", padding: "10px" }}
                        >
                          No comments available
                        </td>
                      </tr>
                    )}
                    <tr height="30px"></tr>
                  </tbody>
                </React.Fragment>
              ) : (
                <React.Fragment>
                  <thead>
                    <tr>
                      <th
                        style={{
                          fontSize: "15px",
                          padding: "10px",
                          textAlign: "center",
                          fontWeight: "400",
                          position: "relative",
                          bottom: "0.5px",
                        }}
                      >
                        Pattern Comments
                      </th>
                      <th
                        style={{
                          fontSize: "15px",
                          padding: "10px",
                          textAlign: "center",
                          fontWeight: "400",
                        }}
                      >
                        Dispatch Comments
                      </th>
                    </tr>
                    <tr style={{ height: "30px" }}></tr>
                  </thead>
                  <tbody>
                    {this.state.measurements1 &&
                    this.state.measurements1.length > 0 ? (
                      this.state.measurements1.map((row, index) => (
                        <tr
                          key={index}
                          style={{
                            backgroundColor:
                              index % 2 === 0 ? "#F2F2EF" : "white",
                          }}
                        >
                          <td style={{ padding: "10px", fontSize: "12px" }}>
                            {/* <input
                type="text"
                value={row.comments}
                onChange={(e) => {
                  let trimmedValue = e.target.value.replace(/^\s+/, ""); // Remove leading spaces
                  this.handleInputChange(index, "comments", trimmedValue);
                }}
                maxLength={75}
                style={{
                  width: "160px",
                  padding: "6px",
                  boxSizing: "border-box",
                  borderRadius: "4px",
                  border: "1px solid",
                  fontSize: "12px",
                }}
                disabled={this.state.action === "view"}
              /> *

                            <textarea
                              value={row.comments}
                              disabled={true}
                              rows={2}
                              style={{ padding: "5px" }}
                              placeholder="Comments"
                            />
                          </td>
                          <td style={{ padding: "10px", fontSize: "12px" }}>
                            {/* <input
                              type="text"
                              value={row.dispatchComments}
                              onChange={(e) => {
                                let trimmedValue = e.target.value.replace(/^\s+/, ""); // Remove leading spaces
                                this.handleInputChange(index, "dispatchComments", trimmedValue);
                              }}
                              maxLength={75}
                              style={{
                                width: "160px",
                                padding: "6px",
                                boxSizing: "border-box",
                                borderRadius: "4px",
                                border: "1px solid",
                                fontSize: "12px",
                              }}
                              disabled={this.state.action === "view"}
                              placehoder="Comments"
                            /> *
                            <textarea
                              value={row.dispatchComments}
                              onChange={(e) => {
                                let trimmedValue = e.target.value.replace(
                                  /^\s+/,
                                  ""
                                ); // Remove leading spaces
                                this.handleInputChange(
                                  index,
                                  "dispatchComments",
                                  trimmedValue
                                );
                              }}
                              rows={2}
                              maxLength={75}
                              style={{
                                // width: "160px",
                                padding: "5px",
                                // boxSizing: "border-box",
                                // borderRadius: "4px",
                                // border: "1px solid",
                                // fontSize: "12px",
                              }}
                              disabled={this.state.action === "view"}
                              placeholder="Comments"
                            />
                          </td>
                        </tr>
                      ))
                    ) : (
                      <tr>
                        <td
                          colSpan="2"
                          style={{ textAlign: "center", padding: "10px" }}
                        >
                          No comments available
                        </td>
                      </tr>
                    )}
                    <tr height="30px"></tr>
                  </tbody>
                </React.Fragment>
              )}
            </table> */}
          </div>
          <div style={{ margin: "10px", marginLeft: "34px" }}>
            {/* <button
              className="addmoreButton"
              ref={this.state.buttonRef1}
              onClick={this.handleAddMore}
              style={{}}
              disabled={this.state.action === "view"}
            >
              <span>Add More</span>
              <div></div>
              <i
                className={`fa ${
                  this.state.isOpen2 && this.state.showDropdown1
                    ? "fa-close"
                    : "fa-plus"
                }`}
                style={{ fontSize: "12px" }}
              ></i>{" "}
            </button> */}
            <button
  className="addmoreButton"
  onClick={this.handleAddMore}
  disabled={this.state.action === "view"}
>
  <span>Add More</span>
  <i className="fa fa-plus" style={{ fontSize: "12px" }}></i>
</button>
{/* {this.state.showModal && (
  <div className="modal-overlay">
    <div className="modal-content1">
      <h4>Select POMs</h4>

      <ul className="modal-list1">
        {this.state.additionalData.length > 0 ? (
          this.state.additionalData.map((item) => (
            <li key={item.placeofMeasurement} className="modal-item">
              <input
                type="checkbox"
                style={{
                  marginRight: "8px",
                  position: "static", // Reset position
                  left: "auto", // Reset left positioning
                  opacity: 1,
                  cursor: "pointer",
                  marginBottom:"0px",
                  width:"auto",
                }}
                checked={this.state.selectedMeasurements.some(
                  (m) => m.placeofMeasurement === item.placeofMeasurement
                )}
                onChange={() => this.handleCheckboxChange(item)}
              />
              {item.placeofMeasurement}
            </li>
          ))
        ) : (
          <li className="modal-no-data">No data available</li>
        )}
      </ul>
      <button onClick={() => this.setState({ showModal: false })} className="modal-close">
        Ok
      </button>
    </div>
  </div>
)} */}
{/* {this.state.showModal && (
  <div className="modal-overlay">
    <div className="modal-content1">
      <h4>Select POMs</h4>

      <div className="modal-table">
        {/* Table Header *
        <div className="modal-table-header">
        <span className="modal-th checkbox-col">
        </span>

        <span className="modal-th">Code</span>
          <span className="modal-th">Description</span>
        </div>

        {/* Table Body *
        <ul className="modal-table-body">
          {this.state.additionalData.length > 0 ? (
            this.state.additionalData.map((item) => (
              <li key={item.placeofMeasurement} className="modal-tr">
                <span className="modal-td checkbox-col">
                  <input
                    type="checkbox"
                    checked={this.state.selectedMeasurements.some(
                      (m) => m.placeofMeasurement === item.placeofMeasurement
                    )}
                    onChange={() => this.handleCheckboxChange(item)}
                    style={{
                      marginRight: "8px",
                      position: "static", // Reset position
                      left: "auto", // Reset left positioning
                      opacity: 1,
                      cursor: "pointer",
                      marginBottom:"0px",
                      width:"auto",
                    }}
                  />
                </span>
                <span className="modal-td">{item.code}</span>
                <span className="modal-td">{item.placeofMeasurement}</span>
              </li>
            ))
          ) : (
            <li className="modal-no-data">No data available</li>
          )}
        </ul>
      </div>

      <button onClick={() => this.setState({ showModal: false })} className="modal-close">
        Ok
      </button>
    </div>
  </div>
)} */}

{this.state.showModal && (
  <div className="modal-overlay">
    <div className="modal-content1">
    <i
    className="fa fa-times"
    onClick={() => this.setState({ showModal: false })}
    style={{
      position: "absolute",
      top: "10px",
      right: "10px",
      fontSize: "18px",
      cursor: "pointer",
      color: "#555",
    }}
    aria-label="Close modal"
  />
      <h4>Select POMs</h4>
      <div style={{ position: "relative", marginBottom: "10px" }}>
  <input
    type="text"
    className="form-control"
    placeholder="Search Code or Measurement"
    value={this.state.modalSearchInput || ""}
    onChange={(e) => this.setState({ modalSearchInput: e.target.value })}
    style={{
      width: "100%",
      padding: "5px 30px 5px 10px", // space for clear icon
      borderRadius: "4px",
      border: "1px solid #ccc",
    }}
  />
  {this.state.modalSearchInput && (
    <i
      className="fa fa-times"
      onClick={(e) => {
        e.stopPropagation();
        this.setState({ modalSearchInput: "" });
      }}
      style={{
        position: "absolute",
        right: "10px",
        top: "50%",
        transform: "translateY(-50%)",
        cursor: "pointer",
        color: "#777",
      }}
      aria-label="Clear search"
    />
  )}
</div>


      <div className="modal-table-container scrolle">
        <table className="modal-table">
          {/* Table Header */}
          <thead>
            <tr>
              <th className="checkbox-col">
                <input 
                  type="checkbox" 
                  onChange={this.handleSelectAllPOMs} 
                  checked={
                    this.state.additionalData.length > 0 &&
                    this.state.selectedMeasurements.length === this.state.additionalData.length
                  }
                  style={{
                    // marginRight: "8px",
                    position: "static", // Reset position
                    left: "auto", // Reset left positioning
                    opacity: 1,
                    cursor: "pointer",
                    marginBottom:"0px",
                    width:"auto",
                  }}
                />
              </th>
              <th className="wd-80">Code</th>
              <th>Description</th>
            </tr>
          </thead>

          {/* Table Body */}
          <tbody>
            {this.state.additionalData.length > 0 ? (
              // this.state.additionalData.map((item) => (
                this.state.additionalData
    .filter((item) => {
      const search = (this.state.modalSearchInput || "").toLowerCase();
      return (
        item.code.toLowerCase().includes(search) ||
        item.placeofMeasurement.toLowerCase().includes(search)
      );
    })
    .map((item) => (
                <tr key={item.placeofMeasurement}>
                  <td className="checkbox-col">
                    <input
                      type="checkbox"
                      checked={this.state.selectedMeasurements.some(
                        (m) => m.placeofMeasurement === item.placeofMeasurement
                      )}
                      onChange={() => this.handleCheckboxChange(item)}
                      style={{
                        // marginRight: "8px",
                        position: "static", // Reset position
                        left: "auto", // Reset left positioning
                        opacity: 1,
                        cursor: "pointer",
                        marginBottom:"0px",
                        width:"auto",
                      }}
                    />
                  </td>
                  <td className="wd-80">{item.code}</td>
                  <td>{item.placeofMeasurement}</td>
                </tr>
              ))
            ) : (
              <tr>
                <td colSpan="3" className="modal-no-data">No data available</td>
              </tr>
            )}
          </tbody>
        </table>
      </div>

      <button onClick={() => this.setState({ showModal: false })} className="modal-close">
        OK
      </button>
    </div>
  </div>
)}




            {/* {this.state.showDropdown1 && (
              <ul
                style={{
                  position: "sticky",
                  top: "100%", // Places dropdown right below the button
                  left: 0,
                  width: "100%", // Matches the button width
                  zIndex: 2,
                  backgroundColor: "white",
                  overflowY: "auto",
                  maxHeight: "200px",
                  border: "1px solid #ddd",
                  borderRadius: "4px",
                  boxShadow: "0 4px 6px rgba(0, 0, 0, 0.1)",
                }}
                ref={this.state.dropdownRef}
              >
                {this.renderDropdown()}
              </ul>
            )} */}
          </div>
        </div>
      </div>
    );
  }
}

export default MeasurementModal;



// WEBPACK FOOTER //
// ./src/components/SampleRequest/PatternModule/MeasurementModal/MeasurementModal.js